import { ChangeDetectorRef, ElementRef, SimpleChanges, OnChanges, Component, ComponentFactoryResolver, ViewChild, OnInit, Output, Input, EventEmitter, AfterViewInit } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { NIL as NIL_UUID } from 'uuid';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { NewNicaFormComponent } from '../../components/nica-form/new-nica-form.component';
import { environment } from '../../../environments/environment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import { Apiservice } from '../../services/api.service';
import { alert } from 'devextreme/ui/dialog';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import dxDataGrid from 'devextreme/ui/data_grid';
import { exportDataGrid } from 'devextreme/pdf_exporter';
import * as moment from 'moment';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { Utenteservice } from '../../services/utente.service';
import { DxoDropDownOptionsComponent } from 'devextreme-angular/ui/nested';
//import { setTimeout } from 'timers';
import { messagefromComponent } from '../../class/appinterface';
import { WidgetGraficiComponent } from '../../components/widget-grafici/widget-grafici.component';
const mesi = {
  1: "Gennaio",
  2: "Febbraio",
  3: "Marzo",
  4: "Aprile",
  5: "Maggio",
  6: "Giugno",
  7: "Luglio",
  8: "Agosto",
  9: "Settembre",
  10: "Ottobre",
  11: "Novembre",
  12: "Dicembre"
};
@Component({
  selector: 'app-statistiche-rifiuti',
  templateUrl: './statistiche-rifiuti.component.html',
  styleUrls: ['./statistiche-rifiuti.component.css'],
})
export class StatisticheRifiutiComponent extends NicaMaster implements OnInit, AfterViewInit {
  @ViewChild('formStatistica', { static: false }) formStatistica: NewNicaFormComponent;
  @ViewChild('GrigliaMovElab', { static: false }) GrigliaMovElab: NicaAnagraficaComponent;
  @ViewChild('gridTest', { static: false }) gridTest: dxDataGrid;
  @ViewChild('inputElement', { static: false }) inputElement: ElementRef; // adele per mettere gli **** e disattivare input
  @Input() dataSourceType: any;
  @Output() selectedEvent: EventEmitter<any> = new EventEmitter<any>(); // Emit all'esterno
  @Output() selectedEventInitialized: EventEmitter<any> = new EventEmitter<any>(); // Emit all'esterno
  @Output() produttoreSelezionato = new EventEmitter<number>();
  @Input() fileDataInput: any;
  @Input() dataSelect: any;
  @Input() dataInput: any;
  @Input() formData: any;
  debug: boolean = false
  idSelect: number;
  nuovoIdProduttore: number;
  environment: any;
  popupVisibleMultilivello: boolean = false;
  shouldRestoreFieldStates: boolean = false;
  popupSelections: { [key: string]: { ragioneSociale: any[], produttore_sede: any[] } } = {};
  @ViewChild('formSoggetto', { static: false }) formAnagrafica: NewNicaFormComponent;
  buttonCustom2: any[] = [];
  okButton = {
    icon: 'confirm',
    stylingMode: 'contained',
    text: 'Conferma',
    onClick: () => {
      alert("OK ", "ok")
    },
  };
  closeButton = {
    text: 'Close',
    icon: 'glyphicon icon-annulla-form',
    stylingMode: 'outlined',
    type: 'normal',
    onClick: () => {
      this.popupVisibleMultilivello = false;
    },
  };
  // Aggiungi queste proprietà
  formVisible: boolean = true;
  selectedSedeIds: number[] = []; // adele per la preisistenza dei dati
  chartData: any[] = [];
  chartTypes: string[] = ['bar', 'line', 'area', 'pie', 'doughnut'];
  selectedChartType: string = 'bar';
  selectionChangeEnabled: boolean = true;
  MovimentiElaborati: any;
  elementRef: any = {};  // adele oggetto
  ElencoMovimentiElaborati: any;
  popUpRagioneSociale: any[] = [];
  formDataArray: any[];
  constructor(
    public httpBackend: HttpBackend,

    public utenteSerivce: Utenteservice,
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public loader: NgxSpinnerService,
    public formservice: FormsTemplateService,
    public apiservice: Apiservice,
    private http: HttpClient,
    private cdRef: ChangeDetectorRef,
  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService
    );

    this.rowData['idProduttore'];
  }

  formConfig: any;

  pulisci() {
    alert("ho pulito ", "wwww")
  }

  ngAfterViewInit(): void {
    const that = this;
    setTimeout(() => {

      //alert("wwwwww","wwwww");

      //      console.log('this.statisticaTipoRaggruppamento ',this.formStatistica.elementRef)

      //okthat.formStatistica.elementRef['statisticaTipoRaggruppamento'].onInitialized.component.deleteItem(0)     
      //OKthat.formStatistica.elementRef['tipoStatistica'].onInitialized.component.deleteItem(0)

    }, 500);
  }

  messaggioFromComponent(message: messagefromComponent) {
    if (message.destComponent == 'StatisticheRifiutiComponent' && message.traceMessage == 'endAnteprima') {
      this.loader.hide('xls')

    }
    console.log("ecco il messaggio ", message)
    //StatisticheRifiutiComponent
  }
  ngOnInit(): void {
    // Leggi lo stato di shouldRestoreFieldStates dal localStorage
    const shouldRestoreFieldStates = localStorage.getItem('shouldRestoreFieldStates') === 'true';

    // Richiama restoreFieldStates solo se un campo è stato disabilitato
    if (shouldRestoreFieldStates) {
      this.restoreFieldStates();
    }
    this.userComponentService.castMessage.subscribe((message: messagefromComponent) => this.messaggioFromComponent(message));
    this.formConfig = this.formTemplateService.getTemplateService || {};
    //console.log("Template:", this.template);

    this.activatedroute.queryParams
      .subscribe(params => {
        this.currentTabId = params.currentTabId,
          this.currentTabName = params.currentTabName
      });





    this.buttonCustom2 = [
      {
        location: "before",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Genera PDF',
        event: 'soggetto-form'
      },
      {
        location: "before",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Esporta XLS',
        event: 'xls-form'
      },
      // aggiunta bottoni Adele
      {
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Reset',
        event: 'reset-form',


      },
      {
        location: "after",
        widget: "dxButton",
        locateInMenu: "never",
        stylingMode: 'text',
        text: 'Grafici',
        event: 'grafici-form',


      }
    ];

    // blocco di codice di Adele
    //this.loadFormDataFromLocalStorage();
    // Ripristina le selezioni salvate

    const savedSelectedSedeIds = localStorage.getItem('selectedSedeIds');
    if (savedSelectedSedeIds) {
      this.selectedSedeIds = JSON.parse(savedSelectedSedeIds);
      if (this.selectedSedeIds.length > 0) {
        // this.updateSedeOptions(this.selectedSedeIds.map(String), this.formAnagrafica, 'produttore_sede');
      }
    }
  }



  handleSelectionChange(selectedValues: string[], type: string) {
    // Converte l'array di valori selezionati in una stringa di query
    const queryString = selectedValues.map(value => `${type}=${value}`).join('&');
    console.log(`Query String per ${type}:`, queryString);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['idSelect']) {
      // Il valore di idProduttore è cambiato
      console.log('Nuovo idSelect:', changes['idSelect'].currentValue);
    }
  }


  closeMultilivello(ev) {
    if (ev === 15) {
      console.log("confermo selezione ", ev)
    }
    this.popupVisibleMultilivello = false;
  }
  updateIdSelect() {
    if (this.formAnagrafica) {
      this.cdRef.detectChanges(); // Forza la change detection
      console.log(this.idSelect, 'idSelect aggiornato');
    } else {
      console.error('formAnagrafica non è ancora disponibile.');
    }
  }

  renderFormStitistiche(ev) {
    console.log('Logica per renderizzare il form ', ev);
    const that = this;
    setTimeout(() => {

      ev.component.elementRef['daData'].onInitialized.component.option("min", this.utenteSerivce.currentAnno + "/01/01");
      ev.component.elementRef['daData'].onInitialized.component.option("max", this.utenteSerivce.currentAnno + "/12/31");
      //ev.component.elementRef['daData'].onInitialized.component.option("value",this.utenteSerivce.currentAnno +"/01/01");  


      ev.component.elementRef['aData'].onInitialized.component.option("min", this.utenteSerivce.currentAnno + "/01/01", "data");
      ev.component.elementRef['aData'].onInitialized.component.option("max", this.utenteSerivce.currentAnno + "/12/31", "data");
      //ev.component.elementRef['aData'].onInitialized.component.option("value",this.utenteSerivce.currentAnno +"/12/31","data");

    }, 1000);



    setTimeout(() => {
      that.selectionChangeEnabled = false;
      const listData: [] = ev.component.elementRef['causali'].onInitialized.component.option('items');
      if (ev.formData.causali)
        (ev.formData.causali as []).forEach(element => {
          const index = listData.findIndex(x => x['id'] === element);
          if (index > -1)
            ev.component.elementRef['causali'].onInitialized.component.selectItem(index)
        });

      const listDataPosizioni: [] = ev.component.elementRef['soloPosizioni'].onInitialized.component.option('items');
      if (ev.formData.idPosizioneRifiuto)
        (ev.formData.idPosizioneRifiuto as []).forEach(element => {
          const index = listDataPosizioni.findIndex(x => x['id'] === element);
          if (index > -1)
            ev.component.elementRef['soloPosizioni'].onInitialized.component.selectItem(index)
        });
      that.selectionChangeEnabled = true;

      setTimeout(() => {


        //      console.log('this.statisticaTipoRaggruppamento ',this.formStatistica.elementRef)

        that.formStatistica.elementRef['statisticaTipoRaggruppamento'].onInitialized.component.deleteItem(0)
        //OKthat.formStatistica.elementRef['tipoStatistica'].onInitialized.component.deleteItem(0)

      }, 1500);
      // Tipo Statistica
      const listDataTipoStatistica: [] = ev.component.elementRef['tipoStatistica'].onInitialized.component.option('items');
      if (ev.formData.tipoStatistica)
        (ev.formData.tipoStatistica as []).forEach(element => {
          const index = listDataTipoStatistica.findIndex(x => x['id'] === element);
          if (index > -1)
            ev.component.elementRef['tipoStatistica'].onInitialized.component.selectItem(index)
        });
      //statisticaTipoRaggruppamento
      const statisticaTipoRaggruppamento: [] = ev.component.elementRef['statisticaTipoRaggruppamento'].onInitialized.component.option('items');
      if (ev.formData.statisticaTipoRaggruppamento)
        (ev.formData.statisticaTipoRaggruppamento as []).forEach(element => {
          const index = statisticaTipoRaggruppamento.findIndex(x => x['id'] === element);
          if (index > -1)
            ev.component.elementRef['statisticaTipoRaggruppamento'].onInitialized.component.selectItem(index)
        });
      //statisticaFiltroMovimenti
      const statisticaFiltroMovimenti: [] = ev.component.elementRef['statisticaFiltroMovimenti'].onInitialized.component.option('items');
      if (ev.formData.statisticaFiltroMovimenti)
        (ev.formData.statisticaFiltroMovimenti as []).forEach(element => {
          const index = statisticaTipoRaggruppamento.findIndex(x => x['id'] === element);
          if (index > -1)
            ev.component.elementRef['statisticaFiltroMovimenti'].onInitialized.component.selectItem(index)
        });



    }, 500);


    //e.component.option("min", new Date(now.getFullYear(), now.getMonth(), now.getDate() + 10));
  }


  formItemsEvent(ev) {
    console.log("eccolooooooooooooooooooooKKKKKKKKKKKK ", ev)
    const that = this;
    //let TipoStatistica=this.formStatistica.dataSet['tipoStatistica'][0]
    if (ev.name == 'selectedItemLista' && ev.dataFields == 'NonUsataPerIlMomentotipoStatistica') {
      this.formStatistica.itemOption('filtroGruppo.daData', 'visible', (ev.value[0] != 4))
      this.formStatistica.itemOption('filtroGruppo.aData', 'visible', (ev.value[0] !== 4))
      this.formStatistica.itemOption('filtroGruppo.mensile', 'visible', (ev.value[0] == 4))
      this.formStatistica.itemOption('filtroGruppo.annuale', 'visible', (ev.value[0] == 4))
    }

    if (ev.event && ev.event.name == 'selectChange' && ev.dataFields == 'statisticaTipoRaggruppamento') {
      if (ev.event.addedItems.length > 0) { // Aggiunto elemento posizione
        if (ev.event.addedItems[0].id === null) {
          ev.masterComponent.elementRef['statisticaTipoRaggruppamento'].onInitialized.component.unselectItem(0)
        }
      }
    }

    if (ev.name == 'selectedItemLista' && ev.dataFields == 'statisticaTipoRaggruppamento') {
      if (ev.value === null) {
        ev.masterComponent.elementRef['statisticaTipoRaggruppamento'].onInitialized.component.unselectAll()
        ev.masterComponent.elementRef['statisticaTipoRaggruppamento'].onInitialized.component.selectItem(0)

      }
    }


    if (ev.name == 'onValueChanged') {
      //
      if (ev.campo.dataField === 'destinatario_Descrizione_Sede') {
        this.formStatistica.dataSet['descrizione_MagazzinoDestinatario_Descrizione'] = []
        this.formStatistica.dataSet['autorizzazioneDestinatario'] = null
        this.formStatistica.dataSet['cantiereDestinatario_Descrizione'] = null
        this.formStatistica.dataSet['idMagazzinoDestinatario'] = null
        this.formStatistica.dataSet['idCantiereFuoriUlDestinatario'] = null
      }
      if (ev.campo.dataField === 'destinatario_Descrizione_Soggetto') {
        this.formStatistica.itemOption('sceltaProduttore.descrizione_MagazzinoDestinatario_Descrizione', 'disabled', !(ev.formData.destinatario_Id_Soggetto > 0))
        this.formStatistica.itemOption('sceltaProduttore.destinatario_Descrizione_Sede', 'disabled', !(ev.formData.destinatario_Id_Soggetto > 0))
        this.formStatistica.itemOption('sceltaProduttore.autorizzazioneDestinatario', 'disabled', !(ev.formData.destinatario_Id_Soggetto > 0))
        this.formStatistica.itemOption('sceltaProduttore.cantiereDestinatario_Descrizione', 'disabled', !(ev.formData.destinatario_Id_Soggetto > 0))
        this.formStatistica.dataSet['idCantiereFuoriUl'] = null

        this.formStatistica.dataSet['idAutorizzazioneDestinatario'] = null
        this.formStatistica.dataSet['magazzinoDestinatario_Descrizione'] = null
        this.formStatistica.dataSet['autorizzazioneDestinatario'] = null
        this.formStatistica.dataSet['cantiereDestinatario_Descrizione'] = null
        //this.formStatistica.dataSet['destinatario_Id_Soggetto']=null

        this.formStatistica.dataSet['idMagazzinoDestinatario'] = null
        this.formStatistica.dataSet['idCantiereFuoriUlDestinatario'] = null
      }

      if (ev.campo.dataField === 'trasportatore_Descrizione_Soggetto') {
        this.formStatistica.itemOption('sceltaProduttore.autorizzazioneTrasporsportatore', 'disabled', !(ev.formData.trasportatore_Id_Soggetto > 0))
        this.formStatistica.itemOption('sceltaProduttore.automezzo', 'disabled', !(ev.formData.trasportatore_Id_Soggetto > 0))
        this.formStatistica.itemOption('sceltaProduttore.rimorchio', 'disabled', !(ev.formData.trasportatore_Id_Soggetto > 0))
        this.formStatistica.itemOption('sceltaProduttore.autista', 'disabled', !(ev.formData.trasportatore_Id_Soggetto > 0))
        this.formStatistica.dataSet['automezzo'] = null
        this.formStatistica.dataSet['autorizzazioneTrasporsportatore'] = null
        this.formStatistica.dataSet['rimorchio'] = null
        this.formStatistica.dataSet['autista'] = null
      }
      if (ev.campo.dataField === 'produttore_Descrizione_Sede') {
        this.formStatistica.dataSet['autorizzazione'] = null
        this.formStatistica.dataSet['idMagazzinoProduttore'] = null
        this.formStatistica.dataSet['descrizione_IdMagazzinoProduttore'] = null
        this.formStatistica.dataSet['cantiereProduttore_Descrizione'] = null
      }
      if (ev.campo.dataField === 'produttore_Descrizione_Soggetto') {
        this.formStatistica.itemOption('sceltaProduttore.produttore_Descrizione_Sede', 'disabled', !(ev.formData.produttore_Id_Soggetto > 0))
        this.formStatistica.itemOption('sceltaProduttore.produttore_Descrizione_Sede', 'disabled', !(ev.formData.produttore_Id_Soggetto > 0))
        this.formStatistica.itemOption('sceltaProduttore.autorizzazione', 'disabled', !(ev.formData.produttore_Id_Soggetto > 0))
        this.formStatistica.itemOption('sceltaProduttore.descrizione_IdMagazzinoProduttore', 'disabled', !(ev.formData.produttore_Id_Soggetto > 0))
        this.formStatistica.itemOption('sceltaProduttore.cantiereProduttore_Descrizione', 'disabled', !(ev.formData.produttore_Id_Soggetto > 0))
        //autorizzazione magazzinoProduttore_Descrizione cantiereProduttore_Descrizione
        this.formStatistica.dataSet['autorizzazione'] = null
        this.formStatistica.dataSet['idMagazzinoProduttore'] = null
        this.formStatistica.dataSet['descrizione_IdMagazzinoProduttore'] = []
        this.formStatistica.dataSet['cantiereProduttore_Descrizione'] = []
        //


      }
    }
    if (ev.name == 'beforeMitter') {
      if (ev.campo.dataField === "produttore_Descrizione_Sede") {
        if (ev.formData.produttore_Id_Soggetto === 0 || ev.formData.produttore_Id_Soggetto === undefined) {
          alert("Devi prima selezionare la sede ", "Scelta Produttore")
          ev.cancel = true;
          return;
        }
      }
    }
    //console.log("In Form Event ------------- ",ev)
    if (ev.event && ev.event.name == 'selectChange' && ev.dataFields == 'soloPosizioni') {
      if (!this.selectionChangeEnabled) return;
      //alert("Solo Posizioni ","www")

      if (ev.event.addedItems.length > 0) { // Aggiunto elemento posizione
        let posizioneAggiunta = ev.event.addedItems[0].id;
        this.apiservice.getCausaliByPosizione(ev.event.addedItems[0].id).then(result => {
          let allElements: [];
          const listData: [] = ev.masterComponent.elementRef['causali'].onInitialized.component.option('items');
          that.selectionChangeEnabled = false;
          (result['items'] as []).forEach(element => {
            const index = listData.findIndex(x => x['id'] === element['id']);
            if (index > -1)
              ev.masterComponent.elementRef['causali'].onInitialized.component.selectItem(index)
          });
          that.selectionChangeEnabled = true;
        })
      }

      console.log("Solo Posizioni ", ev)

    }
    if (ev.event && ev.event.name == 'selectChange' && ev.dataFields == 'causali') {
      if (!this.selectionChangeEnabled) return;
      if (ev.event.addedItems.length > 0) { // Aggiunto elemento
        let causaleAggiunta = ev.event.addedItems[0].id;
        //this.http.get("PosizioneCausale?idCausale="+causaleAggiunta)
        this.apiservice.getPosizioniByCauale(ev.event.addedItems[0].id).then(result => {
          //this.formStatistica.dataSet['soloPosizioni']=[result[0]['idPosizioneRifiuto']] ;//  itemOptions("secondoGruppo.soloPosizioni",'value',result[0]['id'])
          let allElements: [];
          const listData: [] = ev.masterComponent.elementRef['soloPosizioni'].onInitialized.component.option('items');
          that.selectionChangeEnabled = false;
          (result as []).forEach(element => {
            const index = listData.findIndex(x => x['id'] === element['idPosizioneRifiuto']);
            if (index > -1)
              ev.masterComponent.elementRef['soloPosizioni'].onInitialized.component.selectItem(index)
          });



          that.selectionChangeEnabled = true;
        })
      }
      if (ev.event.removedItems.length > 0) {
        that.selectionChangeEnabled = false;
        console.log("In Form Event Remove------------- ", ev)
        let causaleRimossa = ev.event.removedItems[0].id;
        //this.http.get("PosizioneCausale?idCausale="+causaleAggiunta)
        let leCausaliAbilitate = ev.selectedElement;
        const listDataCausali: [] = ev.masterComponent.elementRef['causali'].onInitialized.component.option('items');
        const listDataPosizioni: [] = ev.masterComponent.elementRef['soloPosizioni'].onInitialized.component.option('items');

        const listData: [] = ev.masterComponent.elementRef['soloPosizioni'].onInitialized.component.option('items');
        ev.masterComponent.elementRef['soloPosizioni'].onInitialized.component.unselectAll()
        if (leCausaliAbilitate.length == 0) {
          that.selectionChangeEnabled = true;
          return;
        }
        leCausaliAbilitate.forEach(x => {
          that.selectionChangeEnabled = false;
          this.apiservice.getPosizioniByCauale(x).then(result => {
            (result as []).forEach(element => {
              const index = listDataPosizioni.findIndex(x => x['id'] === element['idPosizioneRifiuto']);
              if (index > -1)
                ev.masterComponent.elementRef['soloPosizioni'].onInitialized.component.selectItem(index)
            });
            that.selectionChangeEnabled = true;
            // ciclo le causali selezionate ed abilito le posizioni 
          })

        })



      }

      console.log(" Elementi selezionati  ", ev.value)
    }
    console.log(" formItemsEvent ", ev)
    // non serve a nulla

  }

  AllEvent(e: any) {

    // $("#chartContainer").addClass("d-none");
    //onShowPDF
    if (e.name == 'onEsportatoXls') {
      this.loader.hide('xls');
    }


    if (e.name == 'onShowPDF') {
      if (!this.debug)
        $("#chartContainer").addClass("d-none");
      //alert("show",'pdf')
    }


    //e.name = "onRowPrepared";
    if (e.name == "onRowPrepared" && e.rowType == "data") {
      if (e.data.xSeAccettatoParzialmente === 'X' || e.data.xSeRespinto === 'X') {
        //e.rowElement.style.backgroundColor = 'lightsalmon';
      }
    }
    if (e.name == "onCellPrepared" && e.rowType == "data") {
      //datiCompletiProduttore

      if (e.dataField == 'xt' && e.data['xt'] != undefined) {
        let singleElement = e.data['xt'].split("§");
        let left = 0;
        e.cellElement.innerHTML = ''
        for (let r = 0; r < singleElement.length; r++) {
          e.cellElement.innerHTML += `<div style="margin-left:${left}px;">${singleElement[r]}</div>`;
          left += 50;
        }
        //e.cellElement.innerHTML=`<div style="white-space: normal; word-wrap: break-word;">${e.data.datiCompletiProduttore}</div>`;
        //e.cellElement.innerHTML+=`<div style="margin-left:50px;">${e.data.datiCompletiTrasportatore}</div>`;
        //e.cellElement.innerHTML+=`<div style="margin-left:50px;">${e.data.datiCompletiDestinatario}</div>`;



        if (e.data.colSpan && e.data.colSpan > 0 && e.dataField == e.data.field) {
          //e.cellElement.colSpan = ''+e.data.colSpan
        }
      }

      if (e.dataField == 'datiCompletiProduttore') {
        e.cellElement.innerHTML = `<div style="white-space: normal; word-wrap: break-word;">${e.data.datiCompletiProduttore}</div>`;
      }
      if (e.dataField == 'datiCompletiTrasportatore') {
        e.cellElement.innerHTML = `<div style="white-space: normal; word-wrap: break-word;">${e.data.datiCompletiTrasportatore}</div>`;
      }
      if (e.dataField == 'datiCompletiDestinatario') {
        e.cellElement.innerHTML = `<div style="white-space: normal; word-wrap: break-word;">${e.data.datiCompletiDestinatario}</div>`;
      }

      if (e.dataField == 'produttore_Descrizione_Con_Indirizzo_Full') {
        e.cellElement.innerHTML = `<div style="white-space: normal; word-wrap: break-word;">${e.data.produttore_Descrizione_Con_Indirizzo_Full}</div>`;
      }
      if (e.dataField == 'quantitaKg') {
        if (e.data.xSeAccettatoParzialmente === 'X' || e.data.xSeRespinto === 'X') {

        } else
          if (e.data.xSeScarico == 'X') {
            //e.cellElement.style.backgroundColor = 'lightcoral';
            //e.data.quantitaKg*=-1
            //e.cellElement.innerHTML=`<div style=" white-space: normal; word-wrap: break-word;">+${e.data.quantitaKg}</div>`;
          } else {
            //e.cellElement.style.backgroundColor = 'lightgreen'
            if (e.data.quantitaKg) {

              e.cellElement.innerHTML = `<div style=" white-space: normal; word-wrap: break-word;">+${e.data.quantitaKg}</div>`;

            }

          }
      }
      //console.log("Sono in Cell Prepared ",e)
    }

  }

  validateDataFieldPrepared(e: any) {
    console.log("In prepared ", e);
  }

  nascondiLeTestateSuperflue(colonneAttive) {
    this.GrigliaMovElab.griglia.instance.beginUpdate();
    this.GrigliaMovElab.griglia.instance.columnOption('datiCompletiDestinatario', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('datiCompletiTrasportatore', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('datiCompletiProduttore', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('datiCompletiIntermediario', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('causale_Descrizione', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('xt', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('xtt  ', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('xtotale', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('descrizioneAssegnata', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('quantitaKgPerc', 'visible', false)

    for (let nrd = 0; nrd < 10; nrd++)
      this.GrigliaMovElab.griglia.instance.columnOption('x' + nrd, 'visible', false)
    for (let nrd = 0; nrd < 12; nrd++)
      this.GrigliaMovElab.griglia.instance.columnOption('xm' + nrd, 'visible', false)

    this.GrigliaMovElab.griglia.instance.columnOption('idOperazioneRD', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('dataFormulario', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('numeroFormulario', 'visible', false)
    this.GrigliaMovElab.griglia.instance.columnOption('dataRegistrazione', 'visible', false)

    //Colonne di default visibile
    this.GrigliaMovElab.griglia.instance.columnOption('eer', 'visible', true)
    this.GrigliaMovElab.griglia.instance.columnOption('isStatoFisico', 'visible', true)
    this.GrigliaMovElab.griglia.instance.columnOption('riferimentoEER', 'visible', true)
    // this.GrigliaMovElab.griglia.instance.columnOption('descrizioneAssegnata','visible',true)    
    this.GrigliaMovElab.griglia.instance.columnOption('quantitaKg', 'visible', true)

    this.GrigliaMovElab.griglia.instance.columnOption('xt', 'visible', false)

    if (colonneAttive) {
      let idx = -1;
      colonneAttive.forEach(elem => {

        this.GrigliaMovElab.griglia.instance.columnOption(elem, 'visible', true)
      })
      this.GrigliaMovElab.griglia.instance.endUpdate();
    }

  }



  generaGiorniMese(anno, mese) {
    moment.locale('it');
    // Ottieni il primo giorno del mese
    const primoGiorno = moment(`${anno}-${mese}`, 'YYYY-MM');
    // Ottieni il numero di giorni nel mese
    const giorniNelMese = primoGiorno.daysInMonth();
    // Crea l'array dei giorni
    const giorni = [];
    for (let i = 1; i <= giorniNelMese; i++) {
      const giorno = primoGiorno.clone().date(i);
      giorni.push({
        giorno: i,
        nomeGiorno: giorno.format('dddd'), // Nome del giorno della settimana
        dataCompleta: giorno.format('DD-MM-YYYY'),
        quantita: 0
      });
    }
    return giorni;
  }
  formatString(stringa, lunghezza) {
    if (stringa.length > lunghezza) {
      // Tronca la stringa se è più lunga della lunghezza specificata
      return stringa.slice(0, lunghezza);
    } else {
      // Aggiunge spazi alla fine della stringa per raggiungere la lunghezza specificata
      return stringa.padEnd(lunghezza, ' ');
    }
  }

  calcolaTipoStatistica(data, tipo, raggruppaPer, arrFieldRaggruppamenti, arrFieldRaggruppamentiRelated, arrFieldRaggruppamentiDescrizione, datiForm) {
    /*
  {id:3,descrizione:'Distinta Rif. C.E.R. + Riferimento + St.Fisico'},
  {id:4, descrizione: 'Riepilogo Giornaliero/Mensile'},
  {id:5,descrizione:'Elenco Movimenti'},
  {id:6,descrizione:'Produttori non Movimentati'},
    */
    let xes = arrFieldRaggruppamentiDescrizione.join(',')

    moment.locale('it');
    let dataElab = []
    let beforeData: any;
    let beforeEER = '';
    let beforeTestata: any = {}
    let beforeSF = '';
    let beforeRiferimento = '';
    let beforedescrizioneAssegnata = '';
    let TotaleGenerarele = 0;
    let TotaleAnno = 0;
    let TotaleNelMese = 0;
    let TotaleParziale = 0;
    let beforeFieldRaggup = [];
    let newItemTestata: any
    let newItem: any
    let totaliMesi = [];
    let totaliGiorniNelMesi = [];
    let totaliPerRagguppamento = [];
    let tipoElaborazione = 1;
    this.GrigliaMovElab.titolo='';
    if (tipo == 4) {        // tipoElaborazione Giornaliero=1/mensile=2
      //--------------------------------
      const dtIniziale = moment(datiForm.daData);
      const dtFinale = moment(datiForm.aData);
      let annoIniziale = dtIniziale.year()
      let annoFinale = dtFinale.year()
      let day1 = dtIniziale.month();
      let day2 = dtFinale.month();
      tipoElaborazione = 1;
      if (dtIniziale.year() != dtFinale.year() || dtIniziale.month() != dtFinale.month()) tipoElaborazione = 2 // mensile

      const columns = this.GrigliaMovElab.griglia.instance.getVisibleColumns();
      for (let colonna of columns) {
        this.GrigliaMovElab.griglia.instance.columnOption(colonna['dataField'], 'visible', false)
      }
      //--------------------------------------------
      beforeData = {};
      if (raggruppaPer && raggruppaPer.length == 1 && tipoElaborazione == 2) { // per mese
        const nowIniziale = moment(datiForm.daData).format('D MMMM YYYY');
        const nowFinale = moment(datiForm.aData).format('D MMMM YYYY');
        this.GrigliaMovElab.titolo = "Riepilogo Mensile dal " + nowIniziale + " al " + nowFinale + " raggruppati per " + arrFieldRaggruppamentiDescrizione[0]
        totaliMesi = [];
        for (let r = 0; r < 12; r++) { totaliMesi.push(0) }
        for (let i = 0; i < data.length; i++) {
          TotaleGenerarele += data[i].quantitaKg;
          for (let r = 0; r < arrFieldRaggruppamentiRelated.length; r++) {
            data[i]['x' + r] = data[i][arrFieldRaggruppamentiRelated[r]] || ''
          }
          if (i == 0) beforeData = data[i];
          // controllo Variazioni record precedente
          let variaz = -1;
          for (let r = 0; r < arrFieldRaggruppamenti.length; r++) {
            if (data[i][arrFieldRaggruppamenti[r]] !== beforeData[arrFieldRaggruppamenti[r]]) {
              variaz = r + 1;
              //-------------stampo i risultati (1) ----------------
              let trov = -1;
              let ii = i - 1;
              for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
                data[ii]['x' + t] = data[ii][arrFieldRaggruppamentiRelated[t]] || ''
              }
              data[ii]['xtt'] = '';
              for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
                if (data[ii]['x' + t] > '') {
                  trov++;
                  if (beforeData[arrFieldRaggruppamenti[t]] == data[i][arrFieldRaggruppamenti[t]] && t > 0)
                    data[ii]['xtt'] += " §"
                  else {
                    for (let g = t; g < raggruppaPer.length; g++)
                      data[ii]['xtt'] += arrFieldRaggruppamentiDescrizione[g] + ':' + data[ii]['x' + g] + "§";
                    break;
                  }
                }
                else
                  data[ii]['xtt'] += arrFieldRaggruppamentiDescrizione[t] + ': Nessuno' + "§";
              }
              if (trov == -1) data[ii]['xtt'] = '';
              //------------------------------------------------
              TotaleParziale = 0;
              for (let r = 0; r < totaliMesi.length; r++) {
                TotaleParziale += totaliMesi[r]
              }
              let k = -1;
              let gg = {};
              gg['xtt'] = data[ii]['xtt']
              gg['xtotale'] = TotaleParziale
              for (let r = 0; r < totaliMesi.length; r++) {
                gg['xm' + r] = totaliMesi[r]
                totaliMesi[r] = 0;
              }
              dataElab.push(gg)
              //------------------------------------------------
              const now = moment(data[i]['dataRegistrazione']);
              let mese = now.month()
              if (mese == 0) {
              }
              totaliMesi[mese] += data[i].quantitaKg;
              for (let t = r; t < arrFieldRaggruppamentiRelated.length; t++) {
                data[i]['x' + t] = data[i][arrFieldRaggruppamentiRelated[t]] || ''
              }
              break;
            }
          }
          if (variaz == -1) { // non ci sono variazioni
            for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
              data[i]['x' + t] = '';
            }
            const now = moment(data[i]['dataRegistrazione']);
            let dy = now.month()
            totaliMesi[dy] += data[i].quantitaKg;
          }
          beforeData = data[i];
        }
        //------------------------------------------------
        //-------------stampo i risultati (1) ----------------
        let trov = -1;
        let ii = data.length - 1;
        for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
          data[ii]['x' + t] = data[ii][arrFieldRaggruppamentiRelated[t]] || ''
        }
        data[ii]['xtt'] = '';
        for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
          if (data[ii]['x' + t] > '') {
            trov++;
            if (beforeData[arrFieldRaggruppamenti[t]] == data[ii][arrFieldRaggruppamenti[t]] && t > 0)
              data[ii]['xtt'] += " §"
            else {
              for (let g = t; g < raggruppaPer.length; g++)
                data[ii]['xtt'] += arrFieldRaggruppamentiDescrizione[g] + ':' + data[ii]['x' + g] + "§";
              break;
            }
          }
          else
            data[ii]['xtt'] += arrFieldRaggruppamentiDescrizione[t] + ': Nessuno' + "§";
        }
        if (trov == -1) data[ii]['xtt'] = '';
        TotaleParziale = 0;
        for (let r = 0; r < totaliMesi.length; r++) {
          TotaleParziale += totaliMesi[r]
        }
        let k = -1;
        let gg = {};
        gg['xtt'] = data[ii]['xtt']
        gg['xtotale'] = TotaleParziale
        for (let r = 0; r < totaliMesi.length; r++) {
          gg['xm' + r] = totaliMesi[r]
          totaliMesi[r] = 0;
        }
        dataElab.push(gg)
        this.GrigliaMovElab.griglia.instance.beginUpdate();
        for (let nrd = 0; nrd < 12; nrd++)
          this.GrigliaMovElab.griglia.instance.columnOption('xm' + nrd, 'visible', true)
        this.GrigliaMovElab.griglia.instance.columnOption('xtt', 'visible', true)
        this.GrigliaMovElab.griglia.instance.columnOption('xtt', 'caption', 'Soggetto')
        this.GrigliaMovElab.griglia.instance.columnOption('xtotale', 'visible', true)
        this.GrigliaMovElab.griglia.instance.columnOption('xtotale', 'caption', 'Totale')
        this.GrigliaMovElab.griglia.instance.endUpdate();
        return dataElab;
      }
      // END per mese con ragguppamento
      if (raggruppaPer && raggruppaPer.length == 1 && tipoElaborazione == 1) { // con Rappruppamenti nel mese

        const nowIniziale = moment(datiForm.daData).format('D MMMM YYYY');
        const nowFinale = moment(datiForm.aData).format('D MMMM YYYY');
        this.GrigliaMovElab.titolo = "Riepilogo Giornaliero dal " + nowIniziale + " al " + nowFinale + " raggruppati per " + arrFieldRaggruppamentiDescrizione[0]

        totaliGiorniNelMesi = this.generaGiorniMese(annoIniziale, day1 + 1)
        for (let i = 0; i < data.length; i++) {
          TotaleGenerarele += data[i].quantitaKg;
          for (let r = 0; r < arrFieldRaggruppamentiRelated.length; r++) {
            data[i]['x' + r] = data[i][arrFieldRaggruppamentiRelated[r]] || ''
          }
          if (i == 0) {
            beforeData = data[0];
            const now = moment(data[i]['dataRegistrazione']);
            let dy = now.date() - 1
            totaliGiorniNelMesi[dy]['quantita'] += data[i].quantitaKg;
            for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
              data[i]['x' + t] = data[i][arrFieldRaggruppamentiRelated[t]] || ''
            }
            continue;
          }
          let variaz = -1;
          for (let r = 0; r < arrFieldRaggruppamenti.length; r++) {
            if (data[i][arrFieldRaggruppamenti[r]] !== beforeData[arrFieldRaggruppamenti[r]]) {
              variaz = r + 1;
              //-------------stampo i risultati (1) ----------------
              let trov = -1;
              let ii = i - 1;
              for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
                data[ii]['x' + t] = data[ii][arrFieldRaggruppamentiRelated[t]] || ''
              }
              data[ii]['xtt'] = '';
              for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
                if (data[ii]['x' + t] > '') {
                  trov++;
                  if (beforeData[arrFieldRaggruppamenti[t]] == data[i][arrFieldRaggruppamenti[t]] && t > 0)
                    data[ii]['xtt'] += " §"
                  else {
                    for (let g = t; g < raggruppaPer.length; g++)
                      data[ii]['xtt'] += arrFieldRaggruppamentiDescrizione[g] + ':' + data[ii]['x' + g] + "§";
                    break;
                  }
                }
                else
                  data[ii]['xtt'] += arrFieldRaggruppamentiDescrizione[t] + ': Nessuno' + "§";
              }
              if (trov == -1) data[ii]['xtt'] = '';
              //------------------------------------------------
              TotaleParziale = 0;
              for (let r = 0; r < totaliGiorniNelMesi.length; r++) {
                TotaleParziale += totaliGiorniNelMesi[r]['quantita']
              }

              let k = -1;
              for (let r = 0; r < totaliGiorniNelMesi.length; r += 10) {
                k++;
                let gg = {};
                gg['xtt'] = data[ii]['xtt']
                let arrDesSog = data[ii]['xtt'].split("|");
                if (arrDesSog.length > 0 && k < arrDesSog.length)
                  gg['xtt'] = arrDesSog[k].replaceAll("§", '');//  data[i]['xt']
                else gg['xtt'] = '';
                if (k == 0) gg['xtotale'] = TotaleParziale
                //let k=r % 10;

                let idx = 0;
                // gg['xtt']=data[ii]['xtt']

                for (let g = r; g < r + 10; g++) {
                  //if(r>0) gg['xtt']='';
                  if (g > totaliGiorniNelMesi.length - 1) break;
                  gg['x' + idx] = totaliGiorniNelMesi[g]['quantita']
                  idx++;
                }
                dataElab.push(gg)
              }
              totaliGiorniNelMesi = this.generaGiorniMese(annoIniziale, day1 + 1)
              //------------------------------------------------
              const now = moment(data[i]['dataRegistrazione']);
              let dy = now.date() - 1
              totaliGiorniNelMesi = this.generaGiorniMese(annoIniziale, day1 + 1)
              totaliGiorniNelMesi[dy]['quantita'] += data[i].quantitaKg;
              for (let t = r; t < arrFieldRaggruppamentiRelated.length; t++) {
                data[i]['x' + t] = data[i][arrFieldRaggruppamentiRelated[t]] || ''
              }
              break;
            }
          }
          if (variaz == -1) { // non ci sono variazioni
            for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
              data[i]['x' + t] = '';
            }
            const now = moment(data[i]['dataRegistrazione']);
            let dy = now.date() - 1
            totaliGiorniNelMesi[dy]['quantita'] += data[i].quantitaKg;
          }
          beforeData = data[i];

        }

        //-------------stampo i risultati a fine ciclo----------------
        TotaleParziale = 0;
        for (let r = 0; r < totaliGiorniNelMesi.length; r++) {
          TotaleParziale += totaliGiorniNelMesi[r]['quantita']
        }
        let trov = -1;
        let i = (data.length) - 1;
        for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
          data[i]['x' + t] = data[i][arrFieldRaggruppamentiRelated[t]] || ''
        }

        data[i]['xtt'] = '';
        for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
          if (data[i]['x' + t] > '') {
            trov++;
            if (beforeData[arrFieldRaggruppamenti[t]] == data[i][arrFieldRaggruppamenti[t]] && t > 0)
              data[i]['xtt'] += " §"
            else {
              for (let g = t; g < raggruppaPer.length; g++)
                data[i]['xtt'] += arrFieldRaggruppamentiDescrizione[g] + ':' + data[i]['x' + g] + "§";
              break;
            }
          }
          else
            data[i]['xttt'] += arrFieldRaggruppamentiDescrizione[t] + ': Nessuno' + "§";
        }
        if (trov == -1) data[i]['xtt'] = '';
        //------------------------------------------------

        let k = -1;
        for (let r = 0; r < totaliGiorniNelMesi.length; r += 10) {
          k++
          let gg = {};
          let idx = 0;
          let arrDesSog = data[i]['xtt'].split("|");
          if (arrDesSog.length > 0 && k < arrDesSog.length)
            gg['xtt'] = arrDesSog[k].replaceAll("§", '');//  data[i]['xt']

          if (k == 0) gg['xtotale'] = TotaleParziale
          for (let g = r; g < r + 10; g++) {
            let tr = g % 10;

            //if(r>0) gg['xt']='';
            if (g > totaliGiorniNelMesi.length - 1) break;
            gg['x' + idx] = totaliGiorniNelMesi[g]['quantita']
            idx++;
          }
          dataElab.push(gg)

        }
        let gg = {};
        // 
        let id = uuidv4().replace(/\D/g, '');
        gg['id'] = id;
        gg['xtotale'] = TotaleGenerarele
        dataElab.push(gg);

        this.GrigliaMovElab.griglia.instance.columnOption('xtt', 'visible', true)
        this.GrigliaMovElab.griglia.instance.columnOption('xtt', 'caption', 'Soggetto')
        this.GrigliaMovElab.griglia.instance.columnOption('xtotale', 'visible', true)
        this.GrigliaMovElab.griglia.instance.columnOption('xtotale', 'caption', 'Totale')

        let arrHed = ['1/11/21/31', '2/12/22', '3/13/23', '4/14/24', '5/15/25', '6/16/26', '7/17/27', '8/18/28', '9/19/29', '10/20/30']
        for (let nrd = 0; nrd < 10; nrd++) {
          this.GrigliaMovElab.griglia.instance.columnOption('x' + nrd, 'visible', true)
          this.GrigliaMovElab.griglia.instance.columnOption('x' + nrd, 'caption', arrHed[nrd])

        }

        return dataElab;
      }
      if (!raggruppaPer || raggruppaPer.length == 0) // non ci sono Rappruppamenti
      {
        /*
       const nowIniziale = moment(datiForm.daData);
       const nowFinale = moment(datiForm.aData);
       let annoIniziale=nowIniziale.year()
       let annoFinale=nowFinale.year()
       let day1=nowIniziale.month();
       let day2=nowFinale.month();       
       */
        // if(dtIniziale.year() != dtFinale.year() || dtIniziale.month() != dtFinale.month()) tipoElaborazione=2 // mensile


        this.GrigliaMovElab.griglia.instance.columnOption('x0', 'visible', true)
        this.GrigliaMovElab.griglia.instance.columnOption('quantitaKg', 'visible', true)

        /**************************  GIORNALIERA *************************************** */
        if (tipoElaborazione == 1) { //Giornaliero       
          totaliGiorniNelMesi = this.generaGiorniMese(annoIniziale, day1 + 1)
          console.log("Eccoil mese ", totaliGiorniNelMesi)
          for (let j = 0; j < data.length; j++) {
            const now = moment(data[j]['dataRegistrazione']);
            let dy = now.date() - 1
            totaliGiorniNelMesi[dy]['quantita'] += data[j].quantitaKg;
          } //  end for movimenti

          for (let r = 0; r < totaliGiorniNelMesi.length; r++) {
            let gg = {};

            gg['x0'] = "" + totaliGiorniNelMesi[r]['dataCompleta'].trim() + " " + this.formatString(totaliGiorniNelMesi[r]['nomeGiorno'], 20)
            gg['quantitaKg'] = totaliGiorniNelMesi[r]['quantita']
            TotaleNelMese += totaliGiorniNelMesi[r]['quantita']
            dataElab.push(gg)
          }
          let gg = {};
          gg['x0'] = "Totale "
          gg['quantitaKg'] = TotaleNelMese
          dataElab.push(gg)
          const nowIniziale = moment(datiForm.daData).format('D MMMM YYYY');
          const nowFinale = moment(datiForm.aData).format('D MMMM YYYY');
          this.GrigliaMovElab.titolo = "Riepilogo Giornaliero dal " + nowIniziale + " al " + nowFinale
          return dataElab




        }
        /**************************  MENSILE *************************************** */
        if (tipoElaborazione == 2) { //mensile       
          for (let r = 0; r < 12; r++) {
            totaliMesi.push(0)
          }
          let annoPrec = -1; let mesePrec = -1
          for (let j = 0; j < data.length; j++) {
            const now = moment(data[j]['dataRegistrazione']);
            if (now.year() != annoPrec) {
              let gg = {}
              if (annoPrec != -1) {
                // stampo i mesi 
                for (let r = 0; r < 12; r++) {
                  let gg = {};
                  gg['x0'] = " " + mesi[r + 1]
                  gg['quantitaKg'] = totaliMesi[r]
                  TotaleAnno += totaliMesi[r]
                  dataElab.push(gg);
                  totaliMesi[r] = 0
                }
                gg['x0'] = "Totale Anno(1) "
                gg['quantitaKg'] = TotaleAnno;
                dataElab.push(gg)
                TotaleGenerarele += TotaleAnno;
                gg['x0'] = "Riepilogo Anno " + now.year()
                gg['settings'] = { styleCell: { 'colSpan': 2 } }
                annoPrec = now.year()

              } else {
                gg['x0'] = "Riepilogo Anno " + now.year()
                gg['settings'] = { styleCell: { 'colSpan': 2 } }
                gg['quantitaKg'] = null
                annoPrec = now.year()
                dataElab.push(gg)
              }
            }
            let eccoIlMese = now.month()
            totaliMesi[eccoIlMese] += data[j]['quantitaKg']
          } //  end for movimenti

          for (let r = 0; r < 12; r++) {
            let gg = {};
            gg['x0'] = " " + mesi[r + 1]
            gg['quantitaKg'] = totaliMesi[r]
            TotaleAnno += totaliMesi[r]
            dataElab.push(gg)
          }

          let gg = {};
          gg['x0'] = "Totale "
          gg['quantitaKg'] = TotaleAnno
          dataElab.push(gg)
        }  // end mensile
      }
      const nowIniziale = moment(datiForm.daData).format('D MMMM YYYY');
      const nowFinale = moment(datiForm.aData).format('D MMMM YYYY');
      this.GrigliaMovElab.titolo = "Riepilogo Mensile dal " + nowIniziale + " al " + nowFinale
      this.GrigliaMovElab.griglia.instance.columnOption('x0', 'caption', 'Periodo')

      console.log("Ecco cosa avrei elaborato per mese ", dataElab)
      return dataElab;
    }
    //END TIPO 4444444444444444444444444444


    if (tipo == 5)//'elenco movimenti'
    {
      /*for(let j=0;j<data.length;j++){
        TotaleGenerarele+=data[j].quantitaKg;
      } */
      this.nascondiLeTestateSuperflue(['xt', 'idOperazioneRD', 'dataFormulario', 'numeroFormulario', 'dataRegistrazione', 'datiCompletiProduttore', 'datiCompletiDestinatario', 'datiCompletiTrasportatore']);
      let id = uuidv4().replace(/\D/g, '');
      //const newItem={ id: id, riferimentoEER:'Totale', quantitaKg: TotaleGenerarele};
      //data.push(newItem);

    }
    if (tipo == 5) {

      

      if (!raggruppaPer || raggruppaPer.length == 0) // non ci sono Rappruppamenti
      {
        this.GrigliaMovElab.titolo = 'Elenco Movimenti'
        this.GrigliaMovElab.griglia.instance.columnOption('xtt', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('xt', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('datiCompletiProduttore', 'visibleIndex', 1)
        this.GrigliaMovElab.griglia.instance.columnOption('datiCompletiDestinatario', 'visibleIndex', 2)
        this.GrigliaMovElab.griglia.instance.columnOption('datiCompletiTrasportatore', 'visibleIndex', 3)
        for (let j = 0; j < data.length; j++) {
          TotaleGenerarele += data[j].quantitaKg;
        }
        /*for(let j=0;j<data.length;j++){          
          data[j].quantitaKgPerc=(data[j].quantitaKg/TotaleGenerarele*100).toFixed(2) ;          
        } */
        let id = uuidv4().replace(/\D/g, '');
        const newItem = { id: id, quantitaKg: 'Totale ' + TotaleGenerarele };
        data.push(newItem);
      } else {
        // vedo se  richiesto ordinamento solo per dati P/T/D/I
        
        this.GrigliaMovElab.griglia.instance.columnOption('xtt', 'visible', false)

        this.GrigliaMovElab.titolo = 'Elenco Movimenti raggruppati per ' + xes
        let noTDPI = 0
        for (let r = 0; r < arrFieldRaggruppamentiRelated.length; r++) {
          if (arrFieldRaggruppamentiRelated[r] == 'datiCompletiProduttore' || arrFieldRaggruppamentiRelated[r] == 'datiCompletiTrasportatore' || arrFieldRaggruppamentiRelated[r] == 'datiCompletiDestinatario') {

          } else noTDPI++;
        }

        if (arrFieldRaggruppamentiRelated.length == 1 && noTDPI == 0) {
          for (let r = 0; r < arrFieldRaggruppamentiRelated.length; r++) {

            this.GrigliaMovElab.griglia.instance.columnOption(arrFieldRaggruppamentiRelated[r], 'visibleIndex', r)
          }
          this.GrigliaMovElab.griglia.instance.columnOption('xt', 'visible', false)
        } else {
          for (let r = 0; r < arrFieldRaggruppamentiRelated.length; r++) {
            if (arrFieldRaggruppamentiRelated[r] == 'datiCompletiProduttore' || arrFieldRaggruppamentiRelated[r] == 'datiCompletiTrasportatore' || arrFieldRaggruppamentiRelated[r] == 'datiCompletiDestinatario') {
              this.GrigliaMovElab.griglia.instance.columnOption(arrFieldRaggruppamentiRelated[r], 'visible', false)
            }
          }
        }
      }

    }
    if (tipo == 3)//'Distinta Rif. C.E.R. + Tipol. + St.Fisico'
    {
      this.GrigliaMovElab.titolo='Distinta Rif. C.E.R. + Tipol. + St.Fisico '
      if (raggruppaPer && raggruppaPer.length > 0) {
        //this.nascondiLeTestateSuperflue(arrFieldRaggruppamentiRelated);
        this.nascondiLeTestateSuperflue(['xt', 'descrizioneAssegnata']);
      }
      this.GrigliaMovElab.griglia.instance.columnOption('xtt', 'caption', 'Soggetto')
      if (!raggruppaPer || raggruppaPer.length == 0) // non ci sono Rappruppamenti      
      {
        this.GrigliaMovElab.titolo = 'Distinta Riferimento E.E.R +  Stato Fisico'
        for (let j = 0; j < data.length; j++) {
          TotaleGenerarele += data[j].quantitaKg;
        }
        for (let j = 0; j < data.length; j++) {
          data[j].quantitaKgPerc = (data[j].quantitaKg / TotaleGenerarele * 100).toFixed(2);
        }
        let id = uuidv4().replace(/\D/g, '');
        const newItem = { id: id, quantitaKg: 'Totale ' + TotaleGenerarele };
        data.push(newItem);
        this.GrigliaMovElab.griglia.instance.columnOption('datiCompletiDestinatario', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('datiCompletiTrasportatore', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('datiCompletiProduttore', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('intermediario_Descrizione_Soggetto', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('causale_Descrizione', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('idOperazioneRD', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('dataRegistrazione', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('xt', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('xtt', 'visible', false)
        this.GrigliaMovElab.griglia.instance.columnOption('xtotale', 'visible', false)
        this.GrigliaMovElab.titolo = 'Distinta Riferimento E.E.R +  Stato Fisico'
        // this.GrigliaMovElab.gridWidth=1000
      }
      for (let r = 0; r < arrFieldRaggruppamentiDescrizione.length; r++) {
        if (r == 0) this.GrigliaMovElab.titolo += " raggruppati per "
        if (r > 0) this.GrigliaMovElab.titolo += ","
        this.GrigliaMovElab.titolo = this.GrigliaMovElab.titolo + ' ' + arrFieldRaggruppamentiDescrizione[r]
        
      }
    }
    if (raggruppaPer && raggruppaPer.length > 0) {
      // RIGA AGGIUNTA IL 30 LUGLIO
      this.GrigliaMovElab.griglia.instance.columnOption('xtt', 'visible', false)

      this.GrigliaMovElab.griglia.instance.columnOption('xt', 'caption', 'Soggetto')

      //for(let tr=0;tr<arrFieldRaggruppamentiDescrizione.length;tr++) xes+=arrFieldRaggruppamentiDescrizione[tr]+","
      //this.GrigliaMovElab.titolo='Distinta Riferimento E.E.R +  Stato Fisico ragguppati per '+xes 

      TotaleGenerarele = 0;

      beforeData = data[0];
      let totaliDigruppo = [];
      let newData = [];

//      this.GrigliaMovElab.titolo = 'Distinta Riferimento E.E.R +  Stato Fisico Ragruppate per '
      arrFieldRaggruppamentiRelated.forEach(vl => {
        this.GrigliaMovElab.griglia.instance.columnOption(vl, 'visible', true)
      })
      //this.GrigliaMovElab.titolo += " raggruppata per "
      for (let r = 0; r < arrFieldRaggruppamentiDescrizione.length; r++) {
        
        //if (r > 0) this.GrigliaMovElab.titolo += ","
        //this.GrigliaMovElab.titolo = this.GrigliaMovElab.titolo + ' ' + arrFieldRaggruppamentiDescrizione[r]
        
      }
      //quaaaaaaaaaaaaaaaaaaaa
      for (let i = 0; i < data.length; i++) {
        TotaleGenerarele += data[i].quantitaKg;
        for (let r = 0; r < arrFieldRaggruppamentiRelated.length; r++) {
          data[i]['x' + r] = data[i][arrFieldRaggruppamentiRelated[r]] || ''
        }
        if (i == 0) {
          beforeData = data[0];

          continue;
        }
        // controllo se esitono variazioni in testata

        let variaz = -1;
        for (let r = 0; r < arrFieldRaggruppamenti.length; r++) {
          if (data[i][arrFieldRaggruppamenti[r]] !== beforeData[arrFieldRaggruppamenti[r]]) {
            variaz = r + 1;

            // blocco tutto e risistemo testa
            for (let t = r; t < arrFieldRaggruppamentiRelated.length; t++) {
              data[i]['x' + t] = data[i][arrFieldRaggruppamentiRelated[t]] || ''
            }
            break;
          }
        }

        if (variaz == -1) { // non ci sono variazioni
          for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
            data[i]['x' + t] = '';
          }
        }
        beforeData = data[i];
        continue;
        //-------------- END Controllo testata
        if (i > 0) {
          // newData.push(data[i])
        }
      }

      beforeData = data[0];
      for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
        if (data[0][arrFieldRaggruppamenti[t]] == null || data[0][arrFieldRaggruppamenti[t]] == undefined) data[0][arrFieldRaggruppamenti[t]] = 0
      }
      for (let i = 0; i < data.length; i++) {
        for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
          if (data[i][arrFieldRaggruppamenti[t]] == null || data[0][arrFieldRaggruppamenti[t]] == undefined)
            data[i][arrFieldRaggruppamenti[t]] = 0
        }
        //data[i]['xt']=data

        let trov = -1;
        data[i]['xt'] = '';
        for (let t = 0; t < arrFieldRaggruppamentiRelated.length; t++) {
          if (data[i]['x' + t] > '') {
            trov++;

            if (beforeData[arrFieldRaggruppamenti[t]] == data[i][arrFieldRaggruppamenti[t]] && i > 0)
              data[i]['xt'] += " §"
            else {
              for (let g = t; g < raggruppaPer.length; g++)
                data[i]['xt'] += arrFieldRaggruppamentiDescrizione[g] + ':' + data[i]['x' + g] + "§";
              break;
            }
          }
          else
            data[i]['xt'] += arrFieldRaggruppamentiDescrizione[t] + ': Nessuno' + "§";

        }
        if (trov == -1) data[i]['xt'] = '';
        beforeData = data[i]
      }
      // ************  è una cretinata dovrei farla nel ciclo for ********************
      console.log("XTTTTTTTTTTTTTTTTTT prima", data)
      //TotaleGenerarele=0
      let startGruppo = -1;
      let endGruppo = -1;
      for (let i = 0; i < data.length; i++) {
        // CALCOLO TOTALI GRUPPI
        let variaz = -1;
        if (i == 0) {
          beforeData = data[0];

          // inserisco i Totali         
          for (let r = 0; r < raggruppaPer.length; r++) {
            totaliPerRagguppamento[r] = data[0].quantitaKg;
          }
          variaz = 99;;

        }
        //TotaleGenerarele+=data[0].quantitaKg;
        if (variaz == -1)
          for (let r = 0; r < arrFieldRaggruppamenti.length; r++) {
            if (data[i][arrFieldRaggruppamenti[r]] !== beforeData[arrFieldRaggruppamenti[r]]) {
              variaz = r + 1;
              //for(let rr=r;rr <raggruppaPer.length;rr++){            
              for (let rr = raggruppaPer.length - 1; rr >= r; rr--) {
                if (rr == raggruppaPer.length - 1) {
                  if (startGruppo > -1) //????
                    for (let f = startGruppo; f < dataElab.length; f++) {
                      // data[f]['quantitaKgPerc']=999
                      if (dataElab[f].quantitaKg && dataElab[f].quantitaKg > 0)
                        dataElab[f].quantitaKgPerc = (dataElab[f].quantitaKg / totaliPerRagguppamento[rr] * 100).toFixed(2);

                    }

                  //end gruppo
                  //totaliPerRagguppamento[rr]  
                }
                let nQ = "Totale" + " " + arrFieldRaggruppamentiDescrizione[rr] + ""
                if (tipo == 5)
                  dataElab.push({ riferimentoEER: "Totale " + arrFieldRaggruppamentiDescrizione[rr], quantitaKg: totaliPerRagguppamento[rr] })
                else
                  dataElab.push({ descrizioneAssegnata: "Totale " + arrFieldRaggruppamentiDescrizione[rr], quantitaKg: totaliPerRagguppamento[rr] })

                //dataElab.push({quantitaKg: nQ})
                //dataElab.push({quantitaKg:totaliPerRagguppamento[rr]})

                console.log("(1) Stampo Totale Raggruppamento " + (rr + 1), totaliPerRagguppamento[rr])
                totaliPerRagguppamento[rr] = data[i].quantitaKg;
              }
              break;
            }
          }
        if (variaz == -1) { // non ci sono variazioni        
          for (let r = 0; r < raggruppaPer.length; r++) {
            totaliPerRagguppamento[r] += data[i].quantitaKg;
          }
        }
        beforeData = data[i];

        // END CALCOLO 




        let nrSogetti = data[i]['xt'].split("§");
        let left = 0;
        if (nrSogetti.length > 1) {
          for (let t = 0; t < nrSogetti.length - 2; t++) {
            if (nrSogetti[t].trim == '') {
              //
            } else
              dataElab.push({ xt: nrSogetti[t] + "§", left: left })
            left += 10;
          }
          let gg = { ...data[i] }
          gg['xt'] = nrSogetti[nrSogetti.length - 2] + "§"
          gg['left'] = left;
          gg['settings'] = { styleCell: { left: left, 'font-weight': 200, color: 'red' } }
          dataElab.push(gg)

          if (variaz == 99 || variaz > -1) {

            startGruppo = dataElab.length - 1
          }

        } else {
          data[i]['left'] = left
          dataElab.push(data[i])
        }
      }
      //FINE TABELLA CALCOLO GENERALE
      if (startGruppo > -1)
        for (let f = startGruppo; f < dataElab.length; f++) {
          if (dataElab[f].quantitaKg && dataElab[f].quantitaKg > 0)
            dataElab[f].quantitaKgPerc = (dataElab[f].quantitaKg / totaliPerRagguppamento[totaliPerRagguppamento.length - 1] * 100).toFixed(2);
        }

      for (let rr = raggruppaPer.length - 1; rr > -1; rr--) {
        if (tipo == 5)
          dataElab.push({ riferimentoEER: "Totale " + arrFieldRaggruppamentiDescrizione[rr], quantitaKg: totaliPerRagguppamento[rr] })
        else dataElab.push({ descrizioneAssegnata: "Totale " + arrFieldRaggruppamentiDescrizione[rr], quantitaKg: totaliPerRagguppamento[rr] })

        console.log("(1) Stampo Totale Raggruppamento " + (rr + 1), totaliPerRagguppamento[rr])

      }
      if (tipo == 5)
        dataElab.push({ riferimentoEER: "Totale Generale", quantitaKg: TotaleGenerarele })
      else
        dataElab.push({ descrizioneAssegnata: "Totale Generale", quantitaKg: TotaleGenerarele })

      console.log("XTTTTTTTTTTTTTTTTTT DOPO", dataElab)
      return dataElab;

    }

    return data;
    if (tipo == 3)//'Distinta Rif. C.E.R. + Tipol. + St.Fisico'
    {
      for (let j = 0; j < data.length; j++) {
        TotaleGenerarele += data[j].quantitaKg;
      }

      newItemTestata = { produttore_Descrizione_Con_Indirizzo_Full: '', trasportatore_Descrizione_Soggetto: '', destinatario_Descrizione_Sede: '' };
      beforeData = data[0];
      for (let i = 0; i < data.length; i++) {

        // calcolo Testata
        if (i > 999999991) {
          for (let j = 0; j < arrFieldRaggruppamenti.length; j++) {
            newItemTestata[arrFieldRaggruppamentiRelated[j]] = data[i][arrFieldRaggruppamentiRelated[j]]
            newItemTestata[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeFieldRaggup[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
          }
        }
        // controllo se esitono variazioni in testata
        /*
        let variaz=-1;
        for(let r=0;r<arrFieldRaggruppamenti.length;r++){
          if(data[i][arrFieldRaggruppamenti[r]] !== beforeData[arrFieldRaggruppamenti[r]] ){
            variaz=r+1;
            // blocco tutto e risetemo testa
            for(let t=r+1;t<arrFieldRaggruppamentiRelated.length;t++){
            newItemTestata[arrFieldRaggruppamentiRelated[t]]=beforeData[arrFieldRaggruppamentiRelated[t]]
            newItemTestata[arrFieldRaggruppamenti[t]]=beforeData[arrFieldRaggruppamenti[t]]
            }
            break;
          }
        }
  
        if(i>0 && variaz>-1){
          for(let t=variaz;t<arrFieldRaggruppamentiRelated.length;t++){
            newItemTestata[arrFieldRaggruppamentiRelated[t]]=beforeData[arrFieldRaggruppamentiRelated[t]]
            newItemTestata[arrFieldRaggruppamenti[t]]=beforeData[arrFieldRaggruppamenti[t]]
          }
        }
        if(variaz>-1){         
          let id=uuidv4().replace(/\D/g, '');
          let percQ=(TotaleParziale/TotaleGenerarele*100).toFixed(2) ;
          newItem={ id: id, eer: beforeEER,descrizioneAssegnata:beforedescrizioneAssegnata,riferimentoEER:beforeRiferimento,idStatoFisico:beforeSF,quantitaKg:TotaleParziale,quantitaKgPerc:percQ};
          const combinedSettings = { ...newItem, ...newItemTestata };
  
          for(let t=0;t<arrFieldRaggruppamentiRelated.length;t++){
            //newItemTestata[arrFieldRaggruppamentiRelated[t]]='';
          }
  
  
          dataElab.push(combinedSettings);
          TotaleParziale=data[i].quantitaKg;
          beforeSF=data[i].idStatoFisico; 
          beforeRiferimento=data[i].riferimentoEER  
          beforeData=data[i];
          continue;           
        }
        if(i>0 && variaz==-1){
          for(let t=0;t<arrFieldRaggruppamentiRelated.length;t++){
            //newItemTestata[arrFieldRaggruppamentiRelated[t]]='';
          }
        }
  */
        //-------------- END Controllo testata
        beforeData = data[i];
        if (i == 0) {
          beforeEER = data[i].eer;
          beforeSF = data[i].idStatoFisico;
          beforeRiferimento = data[i].riferimentoEER;
          beforedescrizioneAssegnata = data[i].descrizioneAssegnata;
          // Testata
          for (let j = 0; j < arrFieldRaggruppamenti.length; j++) {
            beforeTestata[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeFieldRaggup[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeTestata[arrFieldRaggruppamentiRelated[j]] = data[i][arrFieldRaggruppamentiRelated[j]]
          }

        }
        if (data[i].eer !== beforeEER) {
          let id = uuidv4().replace(/\D/g, '');
          let percQ = (TotaleParziale / TotaleGenerarele * 100).toFixed(2);
          newItem = { id: id, eer: beforeEER, descrizioneAssegnata: beforedescrizioneAssegnata, riferimentoEER: beforeRiferimento, idStatoFisico: beforeSF, quantitaKg: TotaleParziale, quantitaKgPerc: percQ };
          //newItemTestata
          //newItemTestata.concat(newItem)   
          const combinedSettings = { ...newItem, ...beforeTestata };
          dataElab.push(combinedSettings); //newItem
          TotaleParziale = data[i].quantitaKg;
          beforeSF = data[i].idStatoFisico;
          beforeRiferimento = data[i].riferimentoEER;
          beforeEER = data[i].eer;
          beforedescrizioneAssegnata = data[i].descrizioneAssegnata;
          for (let j = 0; j < arrFieldRaggruppamenti.length; j++) {
            beforeTestata[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeTestata[arrFieldRaggruppamentiRelated[j]] = data[i][arrFieldRaggruppamentiRelated[j]]

            beforeFieldRaggup[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
          }
        } else if (data[i].riferimentoEER !== beforeRiferimento) {
          let id = uuidv4().replace(/\D/g, '');
          let percQ = (TotaleParziale / TotaleGenerarele * 100).toFixed(2);
          const newItem = { id: id, eer: beforeEER, descrizioneAssegnata: beforedescrizioneAssegnata, riferimentoEER: beforeRiferimento, idStatoFisico: beforeSF, quantitaKg: TotaleParziale, quantitaKgPerc: percQ };
          const combinedSettings = { ...newItem, ...beforeTestata };
          dataElab.push(combinedSettings);
          for (let j = 0; j < arrFieldRaggruppamenti.length; j++) {
            beforeTestata[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeTestata[arrFieldRaggruppamentiRelated[j]] = data[i][arrFieldRaggruppamentiRelated[j]]

            beforeFieldRaggup[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
          }
          TotaleParziale = data[i].quantitaKg;
          beforeSF = data[i].idStatoFisico;
          beforeRiferimento = data[i].riferimentoEER

        } else if (data[i].idStatoFisico !== beforeSF) {
          let id = uuidv4().replace(/\D/g, '');
          let percQ = (TotaleParziale / TotaleGenerarele * 100).toFixed(2);
          const newItem = { id: id, eer: beforeEER, descrizioneAssegnata: beforedescrizioneAssegnata, riferimentoEER: beforeRiferimento, idStatoFisico: beforeSF, quantitaKg: TotaleParziale, quantitaKgPerc: percQ };
          const combinedSettings = { ...newItem, ...beforeTestata };
          dataElab.push(combinedSettings);
          TotaleParziale = data[i].quantitaKg;
          beforeSF = data[i].idStatoFisico;
          for (let j = 0; j < arrFieldRaggruppamenti.length; j++) {
            beforeTestata[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeTestata[arrFieldRaggruppamentiRelated[j]] = data[i][arrFieldRaggruppamentiRelated[j]]

            beforeFieldRaggup[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
          }
        } else { TotaleParziale += data[i].quantitaKg; }
      }

      //let id=uuidv4().replace(/\D/g, '');
      //const newItem={ id: id, eer: 'eer',riferimentoEER:'riferimentoEER',idStatoFisico:'idStatoFisico',quantitaKg:'quantitaKg',quantitaKgPerc:'quantitaKgPerc'};
      if (TotaleParziale > 0) {
        let id = uuidv4().replace(/\D/g, '');
        let percQ = (TotaleParziale / TotaleGenerarele * 100).toFixed(2);
        const newItem = { id: id, eer: beforeEER, descrizioneAssegnata: beforedescrizioneAssegnata, riferimentoEER: beforeRiferimento, idStatoFisico: beforeSF, quantitaKg: TotaleParziale, quantitaKgPerc: percQ };
        const combinedSettings = { ...newItem, ...beforeTestata };
        dataElab.push(combinedSettings); //newItem
      }
    }
    if (dataElab[0]['descrizioneAssegnata'].length > 50)
      dataElab[0]['descrizioneAssegnata'] = dataElab[0]['descrizioneAssegnata'].substring(0, 47) + " .."
    for (let i = 1; i < dataElab.length; i++) {
      if (dataElab[i]['descrizioneAssegnata'].length > 50)
        dataElab[i]['descrizioneAssegnata'] = dataElab[i]['descrizioneAssegnata'].substring(0, 47) + " .."

      let prec = dataElab[i];
      for (let x = arrFieldRaggruppamentiRelated.length - 1; x > -1; x--) {
        if (prec[arrFieldRaggruppamenti[x]] !== dataElab[i - 1][arrFieldRaggruppamenti[x]]) {

        } else dataElab[i][arrFieldRaggruppamentiRelated[x]] = dataElab[i][arrFieldRaggruppamentiRelated[x]];//''
      }

    }

    if (raggruppaPer.length == 0) {
      this.GrigliaMovElab.griglia.instance.columnOption('produttore_Descrizione_Con_Indirizzo_Full', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('trasportatore_Descrizione_Soggetto', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('destinatario_Descrizione_Sede', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('intermediario_Descrizione_Soggetto', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('causale_Descrizione', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('operazioneRecupero', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('dataRegistrazione', 'visible', false)
      this.GrigliaMovElab.titolo = 'Distinta Riferimento E.E.R +  Stato Fisico '
    } else {
      this.GrigliaMovElab.griglia.instance.columnOption('produttore_Descrizione_Con_Indirizzo_Full', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('trasportatore_Descrizione_Soggetto', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('destinatario_Descrizione_Sede', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('intermediario_Descrizione_Soggetto', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('causale_Descrizione', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('operazioneRecupero', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('dataRegistrazione', 'visible', false)

      this.GrigliaMovElab.titolo = 'Distinta Riferimento E.E.R +  Stato Fisico Rgaruuppate per .....'
      arrFieldRaggruppamentiRelated.forEach(vl => {
        this.GrigliaMovElab.griglia.instance.columnOption(vl, 'visible', true)
      })
      // Aggiunta Elemento ---------------------------
      //let id=uuidv4().replace(/\D/g, '');
      //const newItem={ id: id, produttore_Descrizione_Con_Indirizzo_Full: 'Aggiunta Riga'};
      //dataElab.splice(1, 0, newItem); // uno sta per posizione
      // ------------------------------------

    }

    //

    let id = uuidv4().replace(/\D/g, '');

    newItem = { id: id, eer: '', descrizioneAssegnata: '', riferimentoEER: '', idStatoFisico: '', quantitaKg: '', quantitaKgPerc: '' };
    dataElab.push(newItem);


    id = uuidv4().replace(/\D/g, '');
    let percQ = (TotaleParziale / TotaleGenerarele * 100).toFixed(2);
    newItem = { id: id, eer: '', descrizioneAssegnata: '', riferimentoEER: '', idStatoFisico: '', quantitaKg: 'Totale     ' + TotaleGenerarele, quantitaKgPerc: '' };
    dataElab.push(newItem);

    return dataElab;

  }

  findAllValuesByKey(jsonObject: any, key: string): any[] {
    let results: any[] = [];

    if (jsonObject.hasOwnProperty(key)) {
      results.push(jsonObject[key]);
    }

    for (let prop in jsonObject) {
      if (jsonObject.hasOwnProperty(prop)) {
        const value = jsonObject[prop];

        // Se l'elemento è un oggetto, richiamare la funzione ricorsivamente
        if (typeof value === 'object' && value !== null) {
          results = results.concat(this.findAllValuesByKey(value, key));
        }
      }
    }

    return results;
  }

  buildQueryAndFetchData(filterString, exportTo) {
    //if (this.rowData) {

    const nowIniziale = moment(this.formStatistica.dataSet.daData)
    const nowFinale = moment(this.formStatistica.dataSet.aData)
    if (nowFinale.isBefore(nowIniziale)) {
      alert("Intervallo di date errato", "Statistica")
      return;
    }
    if (nowIniziale.year() != nowFinale.year()) {
      alert("L'intervallo di date non può comprendere anni diversi", "Statistica")
      return;
    }

    if (filterString > '') {
      const filters: string[] = [];

      /* for (const key in this.rowData) {
         if (this.rowData.hasOwnProperty(key) && this.rowData[key] !== null && this.rowData[key] !== undefined && this.rowData[key] !== '') {
           // Aggiungi ogni filtro con il formato OData
           filters.push(`${key} eq '${this.rowData[key]}'`);
         }
       }
 
       const filterString = filters.join(' and ');
 */

      /*
      { id: '2', descrizione: 'Produttore' },
        { id: '3', descrizione: 'Trasportatore' },
        { id: '4', descrizione: 'Smaltitore' },
        { id: '5', descrizione: 'Intermediario' },
        { id: '6', descrizione: 'CER' },
        { id: '7', descrizione: 'Produttore/CER' },
        { id: '8', descrizione: 'Causale' },
        { id: '9', descrizione: 'Posizione' },
      dataInizioTrasporto
      */
      filterString = filterString.replace('daData', 'dataRegistrazione')
      filterString = filterString.replace('aData', 'dataRegistrazione')
      filterString = filterString.replaceAll("!'", '')

      filterString = filterString.replace('daDataTrasporto', 'dataInizioTrasporto')
      filterString = filterString.replace('aDataTrasporto', 'dataInizioTrasporto')

      //solokg solo peso >0
      if (this.formStatistica.dataSet['solokg'] === true && this.formStatistica.dataSet['solokguguali'] === false) {
        filterString += 'and (((quantitaKg ge 0)))'
        //(((idStatoFisico%20eq%20'1')))
      }
      //
      if (this.formStatistica.dataSet['solokguguali'] === true && this.formStatistica.dataSet['solokg'] === false) {
        filterString += ' and (((quantitaKg eq 0)))'

      }

      //filterString += " and (((xSeCarico eq 'X')))"

      let orderby = ''
      let arrFieldRaggruppamenti = [];
      let arrFieldRaggruppamentiRelated = [];
      let arrFieldRaggruppamentiDescrizione = [];

      let TipoStatistica = (this.formStatistica.dataSet['tipoStatistica']) ? this.formStatistica.dataSet['tipoStatistica'][0] : 0
      let TipoRaggruppamento = (this.formStatistica.dataSet['statisticaTipoRaggruppamento']) ? this.formStatistica.dataSet['statisticaTipoRaggruppamento'] : 0

      if (!TipoStatistica) {
        alert("Selezionata il tipo statistica", "Statistica")
        return;
      }

      if (TipoStatistica == 4 && TipoRaggruppamento.length > 1) {
        alert("Il tipo di statistica selezionata non prevede raggruppamenti multipli", "Statistica")
        return;
      }



      if (this.formStatistica.dataSet['tipoStatistica'] < 2) {
        alert("Devi selezionare il tipo statistica", "Filtri Statistica")
        return;
      }
      orderby = '';
      if (this.formStatistica.dataSet['tipoStatistica'] == 3) {
        //orderby="&orderby=eer,idstatofisico,riferimentoEER";  
        orderby = "eer,idstatofisico,riferimentoEER";
      }
      if (this.formStatistica.dataSet['tipoStatistica'] == 5) {
        orderby = "dataRegistrazione";
      }
      if (this.formStatistica.dataSet['tipoStatistica'] == 4) {
        orderby = "dataRegistrazione";
      }

      if (!TipoRaggruppamento || TipoRaggruppamento.length == 0) {
        if (this.formStatistica.dataSet['tipoStatistica'] == 3)
          orderby = "eer,idstatofisico,riferimentoEER";
        else orderby = "dataRegistrazione";
      } else {
        let optionalOrder = '';


        /*
        let newItemTestata={ produttore_Descrizione_Con_Indirizzo_Full:'',trasportatore_Descrizione_Full:'',destinatario_Descrizione_Con_Indirizzo_Full:''};
        */

        TipoRaggruppamento.forEach(vl => {
          //if(vl==2) {arrFieldRaggruppamentiDescrizione.push('Produttore'),arrFieldRaggruppamentiRelated.push('datiCompletiProduttore'),arrFieldRaggruppamenti.push('idProduttore');optionalOrder+='produttore_Id_Soggetto,idProduttore,';}
          if (vl == 2) {
            //arrFieldRaggruppamentiDescrizione.push('Unita Locale'),arrFieldRaggruppamentiRelated.push('produttore_Descrizione_Con_Indirizzo_Full'),arrFieldRaggruppamenti.push('produttore_Id_Soggetto');
            arrFieldRaggruppamentiDescrizione.push('Produttore'), arrFieldRaggruppamentiRelated.push('datiCompletiProduttore'), arrFieldRaggruppamenti.push('idProduttore'); optionalOrder += 'produttore_Id_Soggetto,idProduttore,';
          }
          if (vl == 3) { arrFieldRaggruppamentiDescrizione.push('Trasportatore'), arrFieldRaggruppamentiRelated.push('datiCompletiTrasportatore'), arrFieldRaggruppamenti.push('idTrasportatore'); optionalOrder += 'trasportatore_Id_Soggetto,idTrasportatore,'; }
          if (vl == 4) { arrFieldRaggruppamentiDescrizione.push('Destinatario'), arrFieldRaggruppamentiRelated.push('datiCompletiDestinatario'), arrFieldRaggruppamenti.push('idDestinatario'); optionalOrder += 'destinatario_Id_Soggetto,idDestinatario,'; }
          if (vl == 5) { arrFieldRaggruppamentiDescrizione.push('Intermediario'), arrFieldRaggruppamentiRelated.push('datiCompletiIntermediario'), arrFieldRaggruppamenti.push('idIntermediario'); optionalOrder += 'intermediario_Id_Soggetto,idIntermediario,'; }
          if (vl == 6) { arrFieldRaggruppamentiDescrizione.push('Causale'), arrFieldRaggruppamentiRelated.push('causale_Descrizione'), arrFieldRaggruppamenti.push('idCausale'); optionalOrder += 'idCausale,'; }
          if (vl == 7) { arrFieldRaggruppamentiDescrizione.push('Posizione'), arrFieldRaggruppamentiRelated.push('posizioneRifiuto_Descrizione'), arrFieldRaggruppamenti.push('idPosizioneRifiuto'); optionalOrder += 'idPosizioneRifiuto,'; }

          //idPosizioneRifiuto
          //posizioneRifiuto_Descrizione
        })

        // arrFieldRaggruppamentiDescrizione.push('Unita Locale'),arrFieldRaggruppamentiRelated.push('produttore_Descrizione_Con_Indirizzo_Full'),arrFieldRaggruppamenti.push('produttore_Id_Soggetto');


        console.log("TIPO RAGG ", arrFieldRaggruppamentiDescrizione)
        orderby = optionalOrder + orderby
      }
      orderby = "&$orderby=" + orderby

      // Controllo se cisono filtri estesi
      let results: any[] = [];
      results = this.findAllValuesByKey(this.formStatistica.dataSet, 'oDataFilter');
      for (let elem in results) {
        if (results[elem] > '') filterString += " and " + results[elem]
      }

      //const odataUrl = `${environment.BASE_API_URL}MovimentoRifiuti/GetAllExtend?$filter=${encodeURIComponent(filterString)}${orderby}`;
      const odataUrl = `MovimentoRifiuti/GetAllExtend?$filter=${encodeURIComponent(filterString)}${orderby}`;
      //const odataUrl = `MovimentoRifiuti/GetAllStats`;

      let datiForm = this.formStatistica.dataSet;


      console.log("Odata query string ", odataUrl)
      if (this.debug)
        $("#chartContainer").removeClass("d-none");
      if (!this.debug)
        this.GrigliaMovElab.griglia.width = 0
      //this.GrigliaMovElab.filter="filter="+encodeURIComponent(filterString);
      //this.GrigliaMovElab.refresh()
      /************* */
      let that = this;

      if (this.debug)
        this.formVisible = false; // Nascondi la form


      let httpNoInterceptor: HttpClient = new HttpClient(this.httpBackend);
      let token: string = this.utenteSerivce.DammiToken();


      that.GrigliaMovElab.myDsStatic = []
      // Effettua la chiamata HTTP
      console.log("*******************************************")
      console.log("Ecco la ODATA ", odataUrl)
      console.log("*******************************************")

      this.apiservice.getExtendMovimenti(odataUrl).then(response => {
        // alert("RITORNO DAL FUTURO 1","La vedo nera")

        this.loader.show('xls');
        let dataSource = response['items'];
        let data = response['items'];
        if (data.length == 0) {
          alert("I filtri non hanno prodotto risultati", "statistica")
          this.loader.hide("xls")
          return;
        }
        // Aggiunta Elemento ---------------------------
        let id = uuidv4().replace(/\D/g, '');
        // const newItem={ id: id, produttore_Descrizione_Con_Indirizzo_Full: 'Aggiunta Riga'};
        //data.splice(0, 0, newItem);
        // ------------------------------------

        that.ElencoMovimentiElaborati = [];
        that.aggiungiDatiCompleti(data) // crea celle con indirizzo completo soggetti

        for (let i = 0; i < data.length; i++) {
            if(data[i].xSeScarico) 
              data[i].quantitaKg=data[i].quantitaKg *-1
        }


        if (this.debug)
          that.ElencoMovimentiElaborati = data;//Visualizzo la griglia completa dei movimenti .map(obj => ({ ...obj }));
        
        if (TipoStatistica != 5 && TipoStatistica != 4)
          data = this.raggruppaPerCerStatofisicoRiferimento(data, ["eer", "idStatoFisico", "riferimentoEER"], "quantitaKg")

      


        data = this.calcolaTipoStatistica(data, TipoStatistica, TipoRaggruppamento, arrFieldRaggruppamenti, arrFieldRaggruppamentiRelated, arrFieldRaggruppamentiDescrizione, datiForm)



        //const risultatoFinale = Object.values(raggruppatoPerCategorie).flatMap(sottocategorie => Object.values(sottocategorie));

        //data=this.raggruppaPerTipoStatistica(data,TipoStatistica,TipoRaggruppamento,arrFieldRaggruppamenti,arrFieldRaggruppamentiRelated);

        //that.ElencoMovimentiElaborati=[];

        that.MovimentiElaborati = data;//Source;//response.items;
        //that.GrigliaMovElab.myDsStatic=[]

        // id=id.replace(/\D/g, '')
        //Inserisce Movimenti in griglia statica
        //that.MovimentiElaborarti=that.MovimentiElaborarti.slice(1,0,{'produttore_Descrizione_Con_Indirizzo_Full':'produttore_Descrizione_Con_Indirizzo_Full'})
        that.GrigliaMovElab.myDsStatic = data;//that.MovimentiElaborati;
        console.log('Dati ricevuti:', response);


        if (exportTo == 'soggetto-form') {
          that.GrigliaMovElab.stampaFile();
          //this.loader.hide('xls');
        }
        else {
          setTimeout(() => {
            // $("#chartContainer").addClass("d-none");
            //onShowPDF

            if (TipoStatistica == 3 || TipoStatistica == 4 || TipoStatistica == 5) { //5=elenco movimenti 4=riepilogo giornaliero 3=distinta rif cer
              that.GrigliaMovElab.griglia.instance.exportToExcel(false);
            } else this.loader.hide('xls');
          }, 500);


        }
      })
      /*
      this.http.get(odataUrl).subscribe(       
        (response: any) => {
          alert("RITORNO DAL FUTURO","La vedo nera")
          let dataSource=response.items;
          let data=response.items;
          // Aggiunta Elemento ---------------------------
          let id=uuidv4().replace(/\D/g, '');
         // const newItem={ id: id, produttore_Descrizione_Con_Indirizzo_Full: 'Aggiunta Riga'};
          //data.splice(0, 0, newItem);
          // ------------------------------------

          that.aggiungiDatiCompleti(data) // crea celle con indirizzo completo soggetti
          that.ElencoMovimentiElaborati=data;//Visualizzo la griglia completa dei movimenti .map(obj => ({ ...obj }));

          if(TipoStatistica !=5)
            data=this.raggruppaPerCerStatofisicoRiferimento(data, ["eer", "idStatoFisico","riferimentoEER"], "quantitaKg")
          data=this.calcolaTipoStatistica(data,TipoStatistica,TipoRaggruppamento,arrFieldRaggruppamenti,arrFieldRaggruppamentiRelated,arrFieldRaggruppamentiDescrizione)
          

          
          //const risultatoFinale = Object.values(raggruppatoPerCategorie).flatMap(sottocategorie => Object.values(sottocategorie));
          
          //data=this.raggruppaPerTipoStatistica(data,TipoStatistica,TipoRaggruppamento,arrFieldRaggruppamenti,arrFieldRaggruppamentiRelated);
          that.MovimentiElaborati=data;//Source;//response.items;
          
          
         // id=id.replace(/\D/g, '')
          //Inserisce Movimenti in griglia statica
          //that.MovimentiElaborarti=that.MovimentiElaborarti.slice(1,0,{'produttore_Descrizione_Con_Indirizzo_Full':'produttore_Descrizione_Con_Indirizzo_Full'})
          that.GrigliaMovElab.myDsStatic=that.MovimentiElaborati;
          console.log('Dati ricevuti:', response);
          


          if (response.items && Array.isArray(response.items)) {
            this.chartData = response.items.map(item => ({
              quantitaKg: item.quantitaKg,
              causale_Descrizione: item.causale_Descrizione,
              ...item
            }));
          } else {
            console.error('Errore: La risposta dell\'API non contiene una proprietà `items` che è un array di oggetti.');
            return;
          }

         
          //this.cdRef.detectChanges();
        },
        (error) => {
          console.error('Errore durante la chiamata API:', error);
        }
      );
      */
    } else {
      console.error('Errore: rowData non definito in buildQueryAndFetchData');
    }
  }

  aggiungiDatiCompleti(MovimentiElaborati) {
    MovimentiElaborati.forEach(elem => {
      //---------- vanno siotituite con una funzione            
      let nuovoTesto = '';
      if (elem.idProduttore > 0) {
        nuovoTesto = elem.produttore_Descrizione_Soggetto + " |"
        if (elem.produttore_Indirizzo_Sede > '') nuovoTesto += " " + elem.produttore_Indirizzo_Sede
        if (elem.produttore_Civico_Sede > '') nuovoTesto += " " + elem.produttore_Civico_Sede
        if (elem.produttore_CAP_Sede > '') nuovoTesto += " " + elem.produttore_CAP_Sede
        if (elem.produttore_Comune_Sede > '') nuovoTesto += " " + elem.produttore_Comune_Sede
        if (elem.produttore_SiglaProvincia_Sede > '') nuovoTesto += " " + elem.produttore_SiglaProvincia_Sede
      }
      elem['datiCompletiProduttore'] = nuovoTesto
      //--------------------------------            
      nuovoTesto = '';
      if (elem.idTrasportatore > 0) {
        nuovoTesto = elem.trasportatore_Descrizione_Soggetto + " |"
        if (elem.trasportatore_Indirizzo_Sede > '') nuovoTesto += " " + elem.trasportatore_Indirizzo_Sede
        if (elem.trasportatore_Civico_Sede > '') nuovoTesto += " " + elem.trasportatore_Civico_Sede
        if (elem.trasportatore_CAP_Sede > '') nuovoTesto += " " + elem.trasportatore_CAP_Sede
        if (elem.trasportatore_Comune_Sede > '') nuovoTesto += " " + elem.trasportatore_Comune_Sede
        if (elem.trasportatore_SiglaProvincia_Sede > '') nuovoTesto += " " + elem.trasportatore_SiglaProvincia_Sede
      }
      elem['datiCompletiTrasportatore'] = nuovoTesto
      //--------------------------------
      nuovoTesto = '';
      if (elem.idDestinatario > 0) {
        nuovoTesto = elem.destinatario_Descrizione_Soggetto + " |"
        if (elem.destinatario_Indirizzo_Sede > '') nuovoTesto += " " + elem.destinatario_Indirizzo_Sede
        if (elem.destinatario_Civico_Sede > '') nuovoTesto += " " + elem.destinatario_Civico_Sede
        if (elem.destinatario_CAP_Sede > '') nuovoTesto += " " + elem.destinatario_CAP_Sede
        if (elem.destinatario_Comune_Sede > '') nuovoTesto += " " + elem.destinatario_Comune_Sede
        if (elem.destinatario_SiglaProvincia_Sede > '') nuovoTesto += " " + elem.destinatario_SiglaProvincia_Sede
      }
      elem['datiCompletiDestinatario'] = nuovoTesto
      //--------------------------------



    })
  }
  // Metodo per mostrare la form
  showForm() {
    $("#chartContainer").addClass("d-none");
    this.formVisible = true;

  }

  // Metodo per gestire il cambio del tipo di grafico
  onChartTypeChange(event: any) {
    this.selectedChartType = event.value;
  }

  // Metodo per scaricare il grafico come PDF
  downloadPDF() {
    setTimeout(() => {
      const data = document.getElementById('chartOnlyContainer'); // Cattura solo il grafico
      if (data) {
        html2canvas(data).then(canvas => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('l', 'mm', 'a4'); // Imposta il formato della pagina A4 orizzontale
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const imgWidth = pageWidth - 20; // Margine di 10mm su entrambi i lati
          const imgHeight = canvas.height * imgWidth / canvas.width;
          let heightLeft = imgHeight;
          let position = 10; // Margine superiore di 10mm

          pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
          heightLeft -= pageHeight - position;

          while (heightLeft > 0) {
            position = heightLeft - imgHeight + 10;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }

          pdf.save('grafico.pdf');
        });
      } else {
        console.error('Elemento chartOnlyContainer non trovato');
      }
    }, 0);
  }

  // Metodo per scaricare i dati del grafico come XLSX con ExcelJS
  downloadXLS() {
    const chartContainer = document.getElementById('chartOnlyContainer'); // Cattura solo il grafico
    if (chartContainer && this.chartData && this.chartData.length > 0) {
      html2canvas(chartContainer).then(canvas => {
        const imgData = canvas.toDataURL('image/png');

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Dati Grafico');

        worksheet.columns = [
          { header: 'Quantità Kg', key: 'quantitaKg', width: 15 },
          { header: 'Causale Descrizione', key: 'causale_Descrizione', width: 30 },
        ];

        this.chartData.forEach((data) => {
          worksheet.addRow(data);
        });

        // Aggiungi l'immagine del grafico
        const imageId1 = workbook.addImage({
          base64: imgData,
          extension: 'png',
        });

        worksheet.addImage(imageId1, {
          tl: { col: 0, row: this.chartData.length + 2 },
          ext: { width: 900, height: 300 }
        });

        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          FileSaver.saveAs(blob, 'dati_grafico.xlsx');
        }).catch((error) => {
          console.error('Errore durante la generazione del file XLSX:', error);
        });
      });
    } else {
      console.error('Nessun dato disponibile per l\'esportazione');
    }
  }

  //FUNZIONI PER DXDATAGRIDMOVIMENTI
  gridTestOnCellPrepared(e) {
    // console.log("gridTestOnCellPrepared ",e)
    if (e.rowType == "data") {
      //datiCompletiProduttore

      if (e.column.dataField == 'soggettoProduttore') {
        let nuovoTesto = '';
        if (e.data.idProduttore > 0) {
          nuovoTesto = '<strong>' + e.data.produttore_Descrizione_Soggetto + '</strong><br>'
          if (e.data.produttore_Indirizzo_Sede > '') nuovoTesto += " " + e.data.produttore_Indirizzo_Sede
          if (e.data.produttore_Civico_Sede > '') nuovoTesto += " " + e.data.produttore_Civico_Sede
          if (e.data.produttore_CAP_Sede > '') nuovoTesto += " " + e.data.produttore_CAP_Sede
          if (e.data.produttore_Comune_Sede > '') nuovoTesto += " " + e.data.produttore_Comune_Sede
          if (e.data.produttore_SiglaProvincia_Sede > '') nuovoTesto += " " + e.data.produttore_SiglaProvincia_Sede
        }
        e.cellElement.innerHTML = `<div style="white-space: normal; word-wrap: break-word;">${nuovoTesto}</div>`;
      }
      if (e.column.dataField == 'soggettoTrasportatore') {
        let nuovoTesto = '';
        if (e.data.idTrasportatore > 0) {
          nuovoTesto = '<strong>' + e.data.trasportatore_Descrizione_Soggetto + '</strong><br>'
          if (e.data.trasportatore_Indirizzo_Sede > '') nuovoTesto += " " + e.data.trasportatore_Indirizzo_Sede
          if (e.data.trasportatore_Civico_Sede > '') nuovoTesto += " " + e.data.trasportatore_Civico_Sede
          if (e.data.trasportatore_CAP_Sede > '') nuovoTesto += " " + e.data.trasportatore_CAP_Sede
          if (e.data.trasportatore_Comune_Sede > '') nuovoTesto += " " + e.data.trasportatore_Comune_Sede
          if (e.data.trasportatore_SiglaProvincia_Sede > '') nuovoTesto += " " + e.data.trasportatore_SiglaProvincia_Sede
        }
        e.cellElement.innerHTML = `<div style="white-space: normal; word-wrap: break-word;">${nuovoTesto}</div>`;
      }
      if (e.column.dataField == 'soggettoDestinatario') {
        let nuovoTesto = '';
        if (e.data.idDestinatario > 0) {
          nuovoTesto = '<strong>' + e.data.destinatario_Descrizione_Soggetto + '</strong><br>'
          if (e.data.destinatario_Indirizzo_Sede > '') nuovoTesto += " " + e.data.destinatario_Indirizzo_Sede
          if (e.data.destinatario_Civico_Sede > '') nuovoTesto += " " + e.data.destinatario_Civico_Sede
          if (e.data.destinatario_CAP_Sede > '') nuovoTesto += " " + e.data.destinatario_CAP_Sede
          if (e.data.destinatario_Comune_Sede > '') nuovoTesto += " " + e.data.destinatario_Comune_Sede
          if (e.data.destinatario_SiglaProvincia_Sede > '') nuovoTesto += " " + e.data.destinatario_SiglaProvincia_Sede
        }
        e.cellElement.innerHTML = `<div style="white-space: normal; word-wrap: break-word;">${nuovoTesto}</div>`;
      }
      /*
   trasportatore_Descrizione_Soggetto
   trasportatore_Indirizzo_Sede
   trasportatore_Civico_Sede
   trasportatore_CAP_Sede
   trasportatore_Comune_Sede
   trasportatore_SiglaProvincia_Sede
 
   destinatario_Descrizione_Soggetto
   destinatario_Indirizzo_Sede
   destinatario_Civico_Sede
   destinatario_CAP_Sede
   destinatario_Comune_Sede
   destinatario_SiglaProvincia_Sede
 
   */
    }
  }
  onExporting(e) {
    const doc = new jsPDF();
    exportDataGrid({
      jsPDFDocument: doc,
      component: e.component
    }).then(() => {
      doc.save('Companies.pdf');
    });
  }
  raggruppaPerTipoStatistica(data, tipo, raggruppaPer, arrFieldRaggruppamenti, arrFieldRaggruppamentiRelated) {
    /*
  {id:3,descrizione:'Distinta Rif. C.E.R. + Riferimento + St.Fisico'},
  {id:4, descrizione: 'Riepilogo Giornaliero/Mensile'},
  {id:5,descrizione:'Elenco Movimenti'},
  {id:6,descrizione:'Produttori non Movimentati'},
    */
    let dataElab = []
    let beforeData: any;
    let beforeEER = '';
    let beforeTestata: any = {}
    let beforeSF = '';
    let beforeRiferimento = '';
    let beforedescrizioneAssegnata = '';
    let TotaleGenerarele = 0;
    let TotaleParziale = 0;

    let beforeFieldRaggup = [];
    let newItemTestata: any
    let newItem: any
    return data;
    if (tipo == 3)//'Distinta Rif. C.E.R. + Tipol. + St.Fisico'
    {
      for (let j = 0; j < data.length; j++) {
        TotaleGenerarele += data[j].quantitaKg;
      }

      newItemTestata = { produttore_Descrizione_Con_Indirizzo_Full: '', trasportatore_Descrizione_Soggetto: '', destinatario_Descrizione_Sede: '' };
      beforeData = data[0];
      for (let i = 0; i < data.length; i++) {

        // calcolo Testata
        if (i > 999999991) {
          for (let j = 0; j < arrFieldRaggruppamenti.length; j++) {
            newItemTestata[arrFieldRaggruppamentiRelated[j]] = data[i][arrFieldRaggruppamentiRelated[j]]
            newItemTestata[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeFieldRaggup[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
          }
        }
        // controllo se esitono variazioni in testata
        /*
        let variaz=-1;
        for(let r=0;r<arrFieldRaggruppamenti.length;r++){
          if(data[i][arrFieldRaggruppamenti[r]] !== beforeData[arrFieldRaggruppamenti[r]] ){
            variaz=r+1;
            // blocco tutto e risetemo testa
            for(let t=r+1;t<arrFieldRaggruppamentiRelated.length;t++){
            newItemTestata[arrFieldRaggruppamentiRelated[t]]=beforeData[arrFieldRaggruppamentiRelated[t]]
            newItemTestata[arrFieldRaggruppamenti[t]]=beforeData[arrFieldRaggruppamenti[t]]
            }
            break;
          }
        }
   
        if(i>0 && variaz>-1){
          for(let t=variaz;t<arrFieldRaggruppamentiRelated.length;t++){
            newItemTestata[arrFieldRaggruppamentiRelated[t]]=beforeData[arrFieldRaggruppamentiRelated[t]]
            newItemTestata[arrFieldRaggruppamenti[t]]=beforeData[arrFieldRaggruppamenti[t]]
          }
        }
        if(variaz>-1){         
          let id=uuidv4().replace(/\D/g, '');
          let percQ=(TotaleParziale/TotaleGenerarele*100).toFixed(2) ;
          newItem={ id: id, eer: beforeEER,descrizioneAssegnata:beforedescrizioneAssegnata,riferimentoEER:beforeRiferimento,idStatoFisico:beforeSF,quantitaKg:TotaleParziale,quantitaKgPerc:percQ};
          const combinedSettings = { ...newItem, ...newItemTestata };
   
          for(let t=0;t<arrFieldRaggruppamentiRelated.length;t++){
            //newItemTestata[arrFieldRaggruppamentiRelated[t]]='';
          }
   
   
          dataElab.push(combinedSettings);
          TotaleParziale=data[i].quantitaKg;
          beforeSF=data[i].idStatoFisico; 
          beforeRiferimento=data[i].riferimentoEER  
          beforeData=data[i];
          continue;           
        }
        if(i>0 && variaz==-1){
          for(let t=0;t<arrFieldRaggruppamentiRelated.length;t++){
            //newItemTestata[arrFieldRaggruppamentiRelated[t]]='';
          }
        }
   */
        //-------------- END Controllo testata
        beforeData = data[i];
        if (i == 0) {
          beforeEER = data[i].eer;
          beforeSF = data[i].idStatoFisico;
          beforeRiferimento = data[i].riferimentoEER;
          beforedescrizioneAssegnata = data[i].descrizioneAssegnata;
          // Testata
          for (let j = 0; j < arrFieldRaggruppamenti.length; j++) {
            beforeTestata[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeFieldRaggup[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeTestata[arrFieldRaggruppamentiRelated[j]] = data[i][arrFieldRaggruppamentiRelated[j]]
          }

        }
        if (data[i].eer !== beforeEER) {
          let id = uuidv4().replace(/\D/g, '');
          let percQ = (TotaleParziale / TotaleGenerarele * 100).toFixed(2);
          newItem = { id: id, eer: beforeEER, descrizioneAssegnata: beforedescrizioneAssegnata, riferimentoEER: beforeRiferimento, idStatoFisico: beforeSF, quantitaKg: TotaleParziale, quantitaKgPerc: percQ };
          //newItemTestata
          //newItemTestata.concat(newItem)   
          const combinedSettings = { ...newItem, ...beforeTestata };
          dataElab.push(combinedSettings); //newItem
          TotaleParziale = data[i].quantitaKg;
          beforeSF = data[i].idStatoFisico;
          beforeRiferimento = data[i].riferimentoEER;
          beforeEER = data[i].eer;
          beforedescrizioneAssegnata = data[i].descrizioneAssegnata;
          for (let j = 0; j < arrFieldRaggruppamenti.length; j++) {
            beforeTestata[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeTestata[arrFieldRaggruppamentiRelated[j]] = data[i][arrFieldRaggruppamentiRelated[j]]

            beforeFieldRaggup[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
          }
        } else if (data[i].riferimentoEER !== beforeRiferimento) {
          let id = uuidv4().replace(/\D/g, '');
          let percQ = (TotaleParziale / TotaleGenerarele * 100).toFixed(2);
          const newItem = { id: id, eer: beforeEER, descrizioneAssegnata: beforedescrizioneAssegnata, riferimentoEER: beforeRiferimento, idStatoFisico: beforeSF, quantitaKg: TotaleParziale, quantitaKgPerc: percQ };
          const combinedSettings = { ...newItem, ...beforeTestata };
          dataElab.push(combinedSettings);
          for (let j = 0; j < arrFieldRaggruppamenti.length; j++) {
            beforeTestata[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeTestata[arrFieldRaggruppamentiRelated[j]] = data[i][arrFieldRaggruppamentiRelated[j]]

            beforeFieldRaggup[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
          }
          TotaleParziale = data[i].quantitaKg;
          beforeSF = data[i].idStatoFisico;
          beforeRiferimento = data[i].riferimentoEER

        } else if (data[i].idStatoFisico !== beforeSF) {
          let id = uuidv4().replace(/\D/g, '');
          let percQ = (TotaleParziale / TotaleGenerarele * 100).toFixed(2);
          const newItem = { id: id, eer: beforeEER, descrizioneAssegnata: beforedescrizioneAssegnata, riferimentoEER: beforeRiferimento, idStatoFisico: beforeSF, quantitaKg: TotaleParziale, quantitaKgPerc: percQ };
          const combinedSettings = { ...newItem, ...beforeTestata };
          dataElab.push(combinedSettings);
          TotaleParziale = data[i].quantitaKg;
          beforeSF = data[i].idStatoFisico;
          for (let j = 0; j < arrFieldRaggruppamenti.length; j++) {
            beforeTestata[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
            beforeTestata[arrFieldRaggruppamentiRelated[j]] = data[i][arrFieldRaggruppamentiRelated[j]]

            beforeFieldRaggup[arrFieldRaggruppamenti[j]] = data[i][arrFieldRaggruppamenti[j]]
          }
        } else { TotaleParziale += data[i].quantitaKg; }
      }

      //let id=uuidv4().replace(/\D/g, '');
      //const newItem={ id: id, eer: 'eer',riferimentoEER:'riferimentoEER',idStatoFisico:'idStatoFisico',quantitaKg:'quantitaKg',quantitaKgPerc:'quantitaKgPerc'};
      if (TotaleParziale > 0) {
        let id = uuidv4().replace(/\D/g, '');
        let percQ = (TotaleParziale / TotaleGenerarele * 100).toFixed(2);
        const newItem = { id: id, eer: beforeEER, descrizioneAssegnata: beforedescrizioneAssegnata, riferimentoEER: beforeRiferimento, idStatoFisico: beforeSF, quantitaKg: TotaleParziale, quantitaKgPerc: percQ };
        const combinedSettings = { ...newItem, ...beforeTestata };
        dataElab.push(combinedSettings); //newItem
      }
    }
    if (dataElab[0]['descrizioneAssegnata'].length > 50)
      dataElab[0]['descrizioneAssegnata'] = dataElab[0]['descrizioneAssegnata'].substring(0, 47) + " .."
    for (let i = 1; i < dataElab.length; i++) {
      if (dataElab[i]['descrizioneAssegnata'].length > 50)
        dataElab[i]['descrizioneAssegnata'] = dataElab[i]['descrizioneAssegnata'].substring(0, 47) + " .."

      let prec = dataElab[i];
      for (let x = arrFieldRaggruppamentiRelated.length - 1; x > -1; x--) {
        if (prec[arrFieldRaggruppamenti[x]] !== dataElab[i - 1][arrFieldRaggruppamenti[x]]) {

        } else dataElab[i][arrFieldRaggruppamentiRelated[x]] = dataElab[i][arrFieldRaggruppamentiRelated[x]];//''
      }

    }

    if (raggruppaPer.length == 0) {
      this.GrigliaMovElab.griglia.instance.columnOption('produttore_Descrizione_Con_Indirizzo_Full', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('trasportatore_Descrizione_Soggetto', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('destinatario_Descrizione_Sede', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('intermediario_Descrizione_Soggetto', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('causale_Descrizione', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('operazioneRecupero', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('dataRegistrazione', 'visible', false)
      this.GrigliaMovElab.titolo = 'Distinta Riferimento E.E.R +  Stato Fisico '
    } else {
      this.GrigliaMovElab.griglia.instance.columnOption('produttore_Descrizione_Con_Indirizzo_Full', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('trasportatore_Descrizione_Soggetto', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('destinatario_Descrizione_Sede', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('intermediario_Descrizione_Soggetto', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('causale_Descrizione', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('operazioneRecupero', 'visible', false)
      this.GrigliaMovElab.griglia.instance.columnOption('dataRegistrazione', 'visible', false)

      this.GrigliaMovElab.titolo = 'Distinta Riferimento E.E.R +  Stato Fisico Raggruppati per .....'
      arrFieldRaggruppamentiRelated.forEach(vl => {
        this.GrigliaMovElab.griglia.instance.columnOption(vl, 'visible', true)
      })
      // Aggiunta Elemento ---------------------------
      //let id=uuidv4().replace(/\D/g, '');
      //const newItem={ id: id, produttore_Descrizione_Con_Indirizzo_Full: 'Aggiunta Riga'};
      //dataElab.splice(1, 0, newItem); // uno sta per posizione
      // ------------------------------------

    }

    //

    let id = uuidv4().replace(/\D/g, '');

    newItem = { id: id, eer: '', descrizioneAssegnata: '', riferimentoEER: '', idStatoFisico: '', quantitaKg: '', quantitaKgPerc: '' };
    dataElab.push(newItem);


    id = uuidv4().replace(/\D/g, '');
    let percQ = (TotaleParziale / TotaleGenerarele * 100).toFixed(2);
    newItem = { id: id, eer: '', descrizioneAssegnata: '', riferimentoEER: '', idStatoFisico: '', quantitaKg: 'Totale     ' + TotaleGenerarele, quantitaKgPerc: '' };
    dataElab.push(newItem);

    return dataElab;


  }
  raggruppaPerCerStatofisicoRiferimento(array, chiavi, colonnaDaSommare) {

    let sommaTi = [];
    let Prec = {};
    let Diff = -1;
    for (let i = 0; i < array.length; i++) {
      let elemento = array[i];
      console.log("CEER + QTA ", elemento.eer, elemento.quantitaKg)
      if (i == 0) {
        Prec = elemento;
        sommaTi.push(elemento)
        continue
      }
      Diff = -1;
      for (let f = 0; f < chiavi.length; f++) {
        if (elemento[chiavi[f]] != Prec[chiavi[f]]) {
          Diff = f;
          Prec = elemento;
          sommaTi.push(elemento)
          break;
        }
      }
      if (Diff == -1) { // non ci sono differenze
        //console.log("Trovato record Uguale Prec",sommaTi[sommaTi.length-1])
        //console.log("Trovato record Uguale Attuale",elemento)
        //console.log("Era ",sommaTi[sommaTi.length-1][colonnaDaSommare])
        sommaTi[sommaTi.length - 1][colonnaDaSommare] = sommaTi[sommaTi.length - 1][colonnaDaSommare] + elemento[colonnaDaSommare]
        //console.log("diventa ",sommaTi[sommaTi.length-1][colonnaDaSommare])
      }
    }
    return sommaTi;

    return array.reduce((risultato, elemento) => {
      // Prendi i valori delle chiavi correnti
      const chiave1 = elemento[chiavi[0]];
      const chiave2 = elemento[chiavi[1]];
      const chiave3 = elemento[chiavi[2]];
      // Se non esiste ancora un oggetto per la prima chiave, crealo
      if (!risultato[chiave1]) {
        risultato[chiave1] = {};
      }
      if (!risultato[chiave2]) {
        risultato[chiave1][chiave2] = {};
      }
      // Se non esiste ancora un oggetto per la seconda chiave, crealo
      if (!risultato[chiave1][chiave2][chiave3]) {
        risultato[chiave1][chiave2][chiave3] = { ...elemento };
        risultato[chiave1][chiave2][chiave3][colonnaDaSommare] = 0;
      }
      risultato[chiave1][chiave2][chiave3][colonnaDaSommare] += elemento[colonnaDaSommare];
      return risultato;
    }, {});

  }

  // blocco di codice per aprire i popup   ADELE




  /*
   forceComponentUpdate(component) {
     const currentItems = component.option('items');
     component.option('items', []);
     component.option('items', currentItems);
     console.log('Component updated with current items.');
   }
 
 
   getComponentsByNormalizedFieldName(formComponent: any, normalizedFieldName: string): any[] {
     const components = [];
     for (const key in formComponent.elementRef) {
       if (this.normalizeFieldName(key) === normalizedFieldName) {
         components.push(formComponent.elementRef[key].onInitialized.component);
       }
     }
     return components;
   }
 */
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  // Salva le selezioni prima di chiudere il popup
  /*saveSelectionsBeforeClose() {
    console.log(this.selectedSedeIds, 'memo')
    localStorage.setItem('selectedSedeIds', JSON.stringify(this.selectedSedeIds));
  }*/
  formatDateForOData(dateString: string): string {
    if (dateString && moment(dateString, moment.ISO_8601, true).isValid()) {
      return moment(dateString).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    }
    return dateString;
  }
  // blocco adele

  formButtonsEvent(selectedValue: any) {
    console.log(selectedValue);

    if (selectedValue.name == 'soggetto-form' || selectedValue.name == 'xls-form') {
      // Logica esistente
      if (this.formStatistica.dataSet['daData'] == null) {
        this.formStatistica.dataSet['daData'] = this.utenteSerivce.currentAnno + "-01-01";
      }
      if (this.formStatistica.dataSet['aData'] == null) {
        this.formStatistica.dataSet['aData'] = this.utenteSerivce.currentAnno + "-12-31";
      }

      this.formStatistica.generaOdata().then(x => {
        this.buildQueryAndFetchData(x, selectedValue.name);
      });
    } else if (selectedValue.name == 'addElencoProduttori') {
      this.openPopup('addElencoProduttori', 'produttore_Descrizione_Soggetto', 'Filtri su Produttori', selectedValue.name);
    } else if (selectedValue.name == 'addElencoTrasportatori') {
      this.openPopup('addElencoTrasportatori', 'trasportatore_Descrizione_Soggetto', 'Filtri su Trasportatori', selectedValue.name);
    } else if (selectedValue.name == 'addElencoDestinatari') {
      this.openPopup('addElencoDestinatari', 'destinatario_Descrizione_Soggetto', 'Filtri su Destinatari', selectedValue.name);
    } else if (selectedValue.name == 'cancElencoProduttori') {
      this.clearPopupData('addElencoProduttori', 'produttore_Descrizione_Soggetto', 'addElencoProduttori');
    } else if (selectedValue.name == 'cancElencoTrasportatori') {
      this.clearPopupData('addElencoTrasportatori', 'trasportatore_Descrizione_Soggetto', 'addElencoTrasportatori');
    } else if (selectedValue.name == 'cancElencoDestinatari') {
      this.clearPopupData('addElencoDestinatari', 'destinatario_Descrizione_Soggetto', 'addElencoDestinatari');
    } else if (selectedValue.name === 'reset-form') {
      const userConfirmation = confirm("Sei sicuro di voler resettare il form?");

      if (userConfirmation) {
        // Resetta tutti i dati del form
        this.formStatistica.dataSet = {}; // Pulisci tutti i dati del form
        this.selectedSedeIds = []; // Resetta le selezioni delle sedi
        this.popupSelections = {}; // Resetta le selezioni dei popup
        this.formVisible = true; // Rendi visibile la form

        // Resetta i campi 'select'
        if (this.formStatistica.formData) {
          this.formStatistica.formData['causali'] = []; // Resetta il campo 'causali' a un array vuoto

          // Resetta anche altri campi se necessario
          this.formStatistica.formData['soloPosizioni'] = []; // Resetta il campo 'soloPosizioni'
        }

        // Resetta i campi select chiamando la funzione di reset delle select
        this.resetSelectFields();

        // Aggiorna la vista e forza la change detection
        this.cdRef.detectChanges();
        alert("Form resettata con successo!", "Reset Form");
      }
    } else if (selectedValue.name === 'grafici-form') {
      console.log('sono grafico');
      this.openPopup2('grafici', 'grafici', 'Statistiche Grafiche', selectedValue.name);
    }

  }
  clearPopupData(serviceName: string, fieldType: string, popupName: string) {
    // Cancella i dati dal formStatistica per il popup corrispondente
    this.formStatistica.dataSet[popupName] = null; // Rimuove i dati salvati

    // Riabilita il campo disabilitato
    this.formStatistica.dataSet[`sceltaProduttore.${fieldType}`] = '';
    this.formStatistica.dataSet[`sceltaProduttore.${fieldType}Disabled`] = false;

    try {
      // Ripristina le opzioni del campo
      // this.formStatistica.itemOption(`sceltaProduttore.${fieldType}`, 'value', '');
      // this.formStatistica.itemOption(`sceltaProduttore.${fieldType}`, 'placeHolder', '');
      this.formStatistica.itemOption(`sceltaProduttore.${fieldType}`, 'disabled', false);
    } catch (error) {
      console.error(`Errore durante l'aggiornamento delle opzioni del campo ${fieldType}:`, error);
    }

    this.cdRef.detectChanges(); // Assicura che i cambiamenti siano rilevati
  }

  openPopup(serviceName: string, fieldType: string, popupTitle: string, popupName: string) {
    //const savedFormData = this.getFormDataByGuid(serviceName, popupName);
    let savedFormData = this.formStatistica.dataSet[serviceName]
    let that = this;
    let data: {
      idUser: 12;

    }
    const guida = Math.random().toString().replace("0.", "");
    let dataToSend = {
      service: serviceName,
      api: '',
      filterKey: '',
      queryString: '',
      dataJson: savedFormData || {},
      type: 'simple',
      nCol: 1,
      remoteOperation: false,
      toolbarTop: false,
      toolbarBottom: true,
      heightForm: 500,
      ngClass: 'atri-dati-form',
    };

    //const guida = Math.random().toString().replace("0.", "");
    this.userComponentService.setNewPopUp(guida, 'NewNicaFormComponent', null, '800', null, dataToSend, false, true, popupTitle);
    this.userComponentService.outputComponent.subscribe(res => {
      if (serviceName == 'addElencoProduttori' || serviceName == 'addElencoTrasportatori' || serviceName == 'addElencoDestinatari') {
        if (res.name == "formContentInitializzed" && res.guid == guida) {
          if (serviceName == 'addElencoProduttori') {

          }
          setTimeout(() => {
            this.selectionChangeEnabled = false;
            this.selectItemsComponentOnInit(res.formData.ragioneSociale, 'ragioneSociale', res.component)
            this.selezionaLeUnitaLocali(res.formData.produttore_sede, 'produttore_sede', res.component);
            this.selectionChangeEnabled = true;
          }, 200);

        }
      }

      if (res.name == "selectedItemLista" && res.guid == guida) {
        let campoDataField = res.campo.dataField;
        if (campoDataField == 'ragioneSociale') {
          //console.log("EVENTOOOOOOOOOOOOOOOOOOO ",res.event)
          if (res.event.addedItems.length > 0) {
            this.selectItemsInComponent([res.event.addedItems[0].id], 'produttore_sede', res.masterComponent, 'add')
            //console.log("EVENTOOOOOOOOOOOOOOOOOOO AGGIUNTO ",res.event.addedItems)
          } else {
            this.selectItemsInComponent([res.event.removedItems[0].id], 'produttore_sede', res.masterComponent, 'remove')
            //console.log("EVENTOOOOOOOOOOOOOOOOOOO RIMOSSO ",res.event.removedItems)

          }

          //????this.selectItemsInComponent(res.value, 'produttore_sede', res.masterComponent)         
        }

      }
      if (res.name == "selectChange" && res.guid == guida) {

      }


      if (res.name == "onValueChanged" && res.guid == guida) {
        let campoDataField = res.campo.dataField;
        if (serviceName == 'addElencoProduttori') {
          if (campoDataField == 'ragioneSociale') {
            console.log("AGGIUNTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA ", res)
            console.log("Ho cambiato valore al soggetto ", campoDataField)
            console.log("Ho cambiato valore al soggetto ", res)
            //          res.masterComponent.elementRef['produttore_sede']['onInitialized']['component'].unselectAll();

            //????this.selectItemsInComponent(res.value, 'produttore_sede', res.masterComponent) 


          }
          //res.masterComponent.elementRef.campoDataField.oninitialized.component
        }

      }
      if (res.name == 'return' && res.guid == guida) {
        this.userComponentService.destroyCurrentOpenPopUp('NewNicaFormComponent');
        return;
      }
      if (res.name == 'submitFormStatic' && res.guid == guida) {
        that.formStatistica.dataSet[popupName] = res.data
        this.handlePopupSaveGenerico(res, fieldType, popupName);
        that.formStatistica.forceSaveSession();
        console.log("ECCCO IN SALVAAAAAAAAAAAAAAAAAAAAAA ", res)
        that.userComponentService.destroyCurrentOpenPopUp('NewNicaFormComponent');
      }
    });

    // Pre-seleziona i campi
    setTimeout(() => {
      //  const savedSelections = this.popupSelections[popupName] || { ragioneSociale: [], produttore_sede: [] };
      //  this.preSelectFields(savedSelections, this.formAnagrafica);
    }, 1000); // Imposta un timeout per attendere il rendering del popup
  }
  openPopup2(serviceName: string, fieldType: string, popupTitle: string, popupName: string) {

    //const savedFormData = this.getFormDataByGuid(serviceName, popupName);
    // Utilizza direttamente formItemsEvent.formData per elaborare i dati
    const dati = this.formStatistica.dataSet || {};  // Usa formData dal formItemsEvent
    console.log('Valore di tipoStatistica:', this.formStatistica.dataSet["tipoStatistica"]);

     // Controllo se tipoStatistica è vuoto o diverso da 5
  if (!Array.isArray(this.formStatistica.dataSet["tipoStatistica"]) || !this.formStatistica.dataSet["tipoStatistica"].includes(5)) {
    alert("Seleziona il tipo statistica 'Elenco Movimenti' prima di aprire i grafici.", 'Errore');
    return; // Interrompi l'esecuzione se tipoStatistica non è corretto
  }

    console.log(dati, 'dati passati alla form')
    let that = this;
    let data: {
      idUser: 12;

    }

    const guida = Math.random().toString().replace("0.", "");
    let dataToSend = {
      dataJson: dati
    };

    //const guida = Math.random().toString().replace("0.", "");
    this.userComponentService.setNewPopUp(guida, 'WidgetGraficiComponent', null, '1200', null, dataToSend, false, true, popupTitle);
    console.log('Dati inviati al componente figlio:', dataToSend);

    // Imposta le date nella formStatistica (form che hai già definito)
    setTimeout(() => {
      // Se esistono date da/a nel formStatistica, imposta i valori min/max nelle date
      if (that.formStatistica && that.formStatistica.dataSet) {
        const daData = that.formStatistica.dataSet.daData || `${this.utenteSerivce.currentAnno}/01/01`;
        const aData = that.formStatistica.dataSet.aData || `${this.utenteSerivce.currentAnno}/12/31`;

        // Imposta i limiti nelle date della form
        if (that.formStatistica.elementRef) {
          const daDataElement = that.formStatistica.elementRef['daData'];
          const aDataElement = that.formStatistica.elementRef['aData'];

          // Se i campi esistono, imposta le opzioni min/max
          if (daDataElement) {
            daDataElement.onInitialized.component.option("min", daData);
            daDataElement.onInitialized.component.option("max", aData);
            daDataElement.onInitialized.component.option("value", daData);
          }

          if (aDataElement) {
            aDataElement.onInitialized.component.option("min", daData);
            aDataElement.onInitialized.component.option("max", aData);
            aDataElement.onInitialized.component.option("value", aData);
          }
        }
      }
    }, 1000);  // Attendi 1 secondo per permettere il rendering della form
  }


  selezionaLeUnitaLocali(selectedIds: number[], fieldName: string, formComponent: any) {
    if (selectedIds == null) return
    if (selectedIds && selectedIds.length == 0) return;

    const listData: [] = formComponent.elementRef[fieldName].onInitialized.component.option('items');
    for (const sede of selectedIds) {
      const index = listData.findIndex(x => x['id'] === sede);
      if (index > -1) {
        formComponent.elementRef[fieldName].onInitialized.component.selectItem(index)
      }
    }

  }
  selectItemsComponentOnInit(selectedIds: number[], fieldName: string, formComponent: any) {
    if (selectedIds == null) return
    if (selectedIds && selectedIds.length == 0) return;
    //this.selectionChangeEnabled=false;
    const listData: [] = formComponent.elementRef[fieldName].onInitialized.component.option('items');
    const indices = selectedIds.reduce((acc, refId) => {
      const itemIndices = listData.reduce((result, item, index) => {
        if (item['id'] === refId) {
          result.push(index);
        }
        return result;
      }, []);
      return acc.concat(itemIndices);
    }, []);
    for (const id of indices) {
      // this.selectItemWithDelay(formComponent, idSede);
      //   this.addSelectedClass(formComponent, idSede);
      formComponent.elementRef[fieldName].onInitialized.component.selectItem(id)
    }
    //this.refreshComponent(fieldName, formComponent);
    setTimeout(() => {
      this.selectionChangeEnabled = true
    }, 100);




  }
  selectItemsInComponent(selectedIds: number[], fieldNameSedi: string, formComponent: any, operation: string) {
    //selectedIds=elenco soggetti selezionati
    //fieldNameSoggetti
    if (!this.selectionChangeEnabled) return;
    this.selectionChangeEnabled = false
    let component;
    component = formComponent.elementRef[fieldNameSedi].onInitialized.component;
    const listaSedi: any[] = component.option('items');
    const indices = selectedIds.reduce((acc, refId) => {
      const itemIndices = listaSedi.reduce((result, item, index) => {
        if (item.idSoggetto === refId) {
          result.push(index);

        }
        return result;
      }, []);
      return acc.concat(itemIndices);
    }, []);
    //unselectAll 

    for (const idSede of indices) {
      if (operation == 'add')
        component.selectItem(idSede)
      else
        component.unselectItem(idSede)
    }
    this.refreshComponent(fieldNameSedi, formComponent);
    this.selectionChangeEnabled = true
  }



  refreshComponent(fieldName: string, formComponent: any) {
    //console.log(fieldName, 'i dati')
    const component = formComponent.elementRef[fieldName].onInitialized.component;
    component._refresh();

  }

  handlePopupSaveGenerico(res: any, fieldType: string, popupName: string) {
    if (res.data) {
      console.log(`Saving data for ${fieldType}:`, res.data);

      // Imposta gli asterischi e disabilita il campo
      this.formStatistica.dataSet[`sceltaProduttore.${fieldType}`] = '************************************************';
      this.formStatistica.dataSet[`sceltaProduttore.${fieldType}Disabled`] = true;

      try {
        // this.formStatistica.itemOption(`sceltaProduttore.${fieldType}`, 'value', '');
        // this.formStatistica.itemOption(`sceltaProduttore.${fieldType}`, 'placeHolder', '************************************************');
        this.formStatistica.itemOption(`sceltaProduttore.${fieldType}`, 'disabled', true);

        // Salva stato dei campi
        const fieldStates = JSON.parse(localStorage.getItem('fieldStates')) || {};
        fieldStates[fieldType] = {
          placeholder: '************************************************',
          disabled: true
        };
        localStorage.setItem('fieldStates', JSON.stringify(fieldStates));

        // Cambia la variabile booleana a true e salvala nel localStorage
        this.shouldRestoreFieldStates = true;
        localStorage.setItem('shouldRestoreFieldStates', 'true');
      } catch (error) {
        console.error(`Errore durante l'aggiornamento delle opzioni del campo ${fieldType}:`, error);
      }

      this.cdRef.detectChanges();
    }
  }


  // Funzione per resettare i campi di selezione
  resetSelectFields() {
    // Resetta lo stato del campo e rimuovi lo stato salvato dal localStorage
    localStorage.removeItem('shouldRestoreFieldStates');
    localStorage.removeItem('fieldStates');

    // Imposta la variabile booleana a false e salvala nel localStorage
    this.shouldRestoreFieldStates = false;
    localStorage.setItem('shouldRestoreFieldStates', 'false');

    // Resetta i campi specifici che potrebbero avere asterischi e disabilitazioni
    this.clearPopupData('addElencoProduttori', 'produttore_Descrizione_Soggetto', 'addElencoProduttori');
    this.clearPopupData('addElencoTrasportatori', 'trasportatore_Descrizione_Soggetto', 'addElencoTrasportatori');
    this.clearPopupData('addElencoDestinatari', 'destinatario_Descrizione_Soggetto', 'addElencoDestinatari');

    // Resetta le select utilizzando le ViewChild per accedere ai componenti
    if (this.formStatistica && this.formStatistica.elementRef) {
      if (this.formStatistica.elementRef['causali'] && this.formStatistica.elementRef['causali'].onInitialized) {
        const causaliComponent = this.formStatistica.elementRef['causali'].onInitialized.component;
        if (causaliComponent) {
          causaliComponent.unselectAll(); // Deseleziona tutte le opzioni
          causaliComponent.option('value', []); // Resetta il valore a un array vuoto
        }
      }

      // Resetta altre select se necessario
      if (this.formStatistica.elementRef['soloPosizioni'] && this.formStatistica.elementRef['soloPosizioni'].onInitialized) {
        const soloPosizioniComponent = this.formStatistica.elementRef['soloPosizioni'].onInitialized.component;
        if (soloPosizioniComponent) {
          soloPosizioniComponent.unselectAll();
          soloPosizioniComponent.option('value', []);
        }
      }
      if (this.formStatistica.elementRef['tipoStatistica'] && this.formStatistica.elementRef['tipoStatistica'].onInitialized) {
        const soloPosizioniComponent = this.formStatistica.elementRef['tipoStatistica'].onInitialized.component;
        if (soloPosizioniComponent) {
          soloPosizioniComponent.unselectAll();
          soloPosizioniComponent.option('value', []);
        }
      }
      if (this.formStatistica.elementRef['statisticaTipoRaggruppamento'] && this.formStatistica.elementRef['statisticaTipoRaggruppamento'].onInitialized) {
        const soloPosizioniComponent = this.formStatistica.elementRef['statisticaTipoRaggruppamento'].onInitialized.component;
        if (soloPosizioniComponent) {
          soloPosizioniComponent.unselectAll();
          soloPosizioniComponent.option('value', []);
        }
      }
      if (this.formStatistica.elementRef['statisticaFiltroMovimenti'] && this.formStatistica.elementRef['statisticaTipoRaggruppamento'].onInitialized) {
        const soloPosizioniComponent = this.formStatistica.elementRef['statisticaFiltroMovimenti'].onInitialized.component;
        if (soloPosizioniComponent) {
          soloPosizioniComponent.unselectAll();
          soloPosizioniComponent.option('value', []);
        }
      }

    }

  }
  restoreFieldStates() {
    const fieldStates = JSON.parse(localStorage.getItem('fieldStates')) || {};

    Object.keys(fieldStates).forEach(fieldType => {
      const fieldState = fieldStates[fieldType];

      try {
        // Applica asterischi e disabilita il campo solo se è stato disabilitato in precedenza
        if (fieldState.disabled) {
          this.formStatistica.dataSet[`sceltaProduttore.${fieldType}`] = '************************************************';
          this.formStatistica.dataSet[`sceltaProduttore.${fieldType}Disabled`] = fieldState.disabled;

          // this.formStatistica.itemOption(`sceltaProduttore.${fieldType}`, 'placeHolder', fieldState.placeholder);
          this.formStatistica.itemOption(`sceltaProduttore.${fieldType}`, 'disabled', fieldState.disabled);
        }
      } catch (error) {
        console.error(`Errore durante l'aggiornamento delle opzioni del campo ${fieldType}:`, error);
      }
    });

    this.cdRef.detectChanges();
  }
}